import { GSD_SOURCE_KEY, GSD_METRIC_KEY_MAP } from '@intelligence/_config/sourceMetric';
import InfoDoc from '@intelligence/_locales/en-US/infoDoc';
import InfoDocENText from '@intelligence/_locales/en-US/text';
import InfoDocCN from '@intelligence/_locales/zh-CN/infoDoc';
import SteamIcon from '@/pages/intelligence/assets/svg/dataSource/vginsights.svg';
// import NewzooIcon from '@/pages/intelligence/assets/svg/dataSource/newzoo-bg.svg';
// import NewzooIcon from '@/pages/home/assets/svg/dataSource/databarin.svg';
import NewzooIcon from '@intelligence/assets/svg/dataSource/databarin-gray.svg';

import MscienceIcon from '@/pages/intelligence/assets/svg/dataSource/mscience-bg.svg';
import NpdIcon from '@/pages/intelligence/assets/svg/dataSource/npd-icon.svg';
// Famitsu is temporarily unavailable in Intelligence pages.
// import FamitsuIcon from '@intelligence/assets/svg/dataSource/japanSales.svg';
import AmpereIcon from '@/pages/intelligence/assets/svg/dataSource/ampere.svg';
import { orderPCConsoleSourceGroups } from '@intelligence/pages/TopCharts/_config/pcConsoleMetricOrdering';
export const NewzooToDatabrain = InfoDocENText.Newzoo;
export const CANCEL_FLAG_MSG = 'REPEAT_CANCEL';

const tableDataSource = {
  mscience: 'mscience',
  steam: 'steamcharts',
  npd: 'npd',
  famitsu: 'famitsu',
  vginsights: 'vginsights',
  gsd: GSD_SOURCE_KEY,
  newzoo: 'newzoo',
  ampere: 'ampere',
  databrain: 'databrain',
  gamalytic: 'gamalytic',
  source_steam: 'source_steam',
  alinea: 'alinea',
};

export const SOURCE_MAP = {
  appannie: 'data.ai',
  appnnie: 'data.ai',
  appstore: 'AppStore',
  appsstore: 'AppStore',
  databrain: 'DataBrain',
  epic: 'Epic',
  googleplay: 'GooglePlay',
  Mscience: 'MScience',
  mscience: 'MScience',
  npd: 'NPD',
  pnd: 'NPD',
  newzoo: 'Newzoo',
  sensortower: 'Sensor Tower',
  steam: 'Steam',
  steamcharts: 'SteamCharts',
  streamhatchet: 'Stream Hatchet',
  stream: 'Stream Hatchet',
  twitch: 'twitch',
  xbox: 'Xbox',
  nintendo: 'Nintendo',
  playstation: 'Play Station',
  hatchet: 'Stream Hatchet',
} as any;

export const newzooMetricsList = [
  {
    // text: 'MAU',
    text: `dbi_metric_mau`,
    value: 'mau',
  },
  {
    // text: 'Player Share',
    text: `dbi_metric_player_share`,
    value: 'player_share',
  },
  {
    // text: 'MAU Growth',
    text: `dbi_metric_mau_growth`,
    value: 'mau_growth',
  },
  {
    // text: 'MAU - New',
    text: `dbi_metric_mau_new`,
    value: 'mau_new',
  },
  {
    // text: 'MAU - Returning',
    text: `dbi_metric_mau_returning`,
    value: 'mau_returning',
  },
  {
    // text: 'Lifetime Players',
    text: `dbi_metric_lifetime_player`,
    value: 'lifetime_player',
  },
  {
    // text: 'Time Spent 0 - 1 hrs',
    text: `dbi_metric_time_spent_0H`,
    value: 'time_spent_0H',
  },
  {
    // text: 'Time Spent 1 - 5 hrs',
    text: `dbi_metric_time_spent_1H`,
    value: 'time_spent_1H',
  },
  {
    // text: 'Time Spent 5 - 10 hrs',
    text: `dbi_metric_time_spent_5H`,
    value: 'time_spent_5H',
  },
  {
    // text: 'Time Spent 10 - 25 hrs',
    text: `dbi_metric_time_spent_10H`,
    value: 'time_spent_10H',
  },
  {
    // text: 'Time Spent 25 - 50 hrs',
    text: `dbi_metric_time_spent_25H`,
    value: 'time_spent_25H',
  },
  {
    // text: 'Time Spent > 50 hrs',
    text: `dbi_metric_time_spent_50H`,
    value: 'time_spent_50H',
  },
  {
    // text: 'Avg Daily Playtime (mins)',
    text: `dbi_metric_avg_daily_playtime`,
    value: 'avg_daily_playtime',
  },
  {
    // text: 'Avg Daily Sessions',
    text: `dbi_metric_avg_daily_sessions`,
    value: 'avg_daily_sessions',
  },
  {
    // text: 'Avg Playtime Per Session (mins)',
    text: `dbi_metric_avg_playtime_per_session`,
    value: 'avg_playtime_per_session',
  },
  {
    // text: 'Avg Monthly Playtime (hours)',
    text: `dbi_metric_avg_monthly_playtime`,
    value: 'avg_monthly_playtime',
  },
  {
    // text: 'Avg Monthly Sessions',
    text: `dbi_metric_avg_monthly_sessions`,
    value: 'avg_monthly_sessions',
  },
  {
    // text: 'Avg Days Played',
    text: `dbi_metric_avg_days_played`,
    value: 'avg_days_played',
  },
  {
    // text: 'Stickiness',
    text: `dbi_metric_stickiness`,
    value: 'stickiness',
  },
  {
    // text: 'Total Hours',
    text: `dbi_metric_total_hours`,
    value: 'total_hours',
  },
  {
    // text: 'Churn %',
    text: `dbi_metric_churn`,
    value: 'churn',
  },
  {
    // text: 'Acquisition %',
    text: `dbi_metric_acquisition`,
    value: 'acquisition',
  },
  {
    // text: 'Retention D1',
    text: `dbi_retention_d1`,
    value: 'retention_d1',
  },
  {
    // text: 'Retention D2',
    text: `dbi_retention_d2`,
    value: 'retention_d2',
  },
  {
    // text: 'Retention D4',
    text: `dbi_retention_d4`,
    value: 'retention_d4',
  },
  {
    // text: 'Retention D7',
    text: `dbi_retention_d7`,
    value: 'retention_d7',
  },
  {
    // text: 'Retention D14',
    text: `dbi_retention_d14`,
    value: 'retention_d14',
  },
  {
    // text: 'Retention D28',
    text: `dbi_retention_d28`,
    value: 'retention_d28',
  },
];

export const ampereMetricsList = [
  { text: 'dbi_metric_mau', value: 'ampere_mau', txtkey: 'dbi_metric_mau', ableDateType: 'month' },
  {
    text: 'dbi_metric_previous_mau',
    value: 'ampere_previous_mau',
    txtkey: 'dbi_metric_previous_mau',
    ableDateType: 'month',
  },
  {
    text: 'dbi_metric_added_mau',
    value: 'ampere_added_mau',
    txtkey: 'dbi_metric_added_mau',
    ableDateType: 'month',
  },
  {
    text: 'dbi_metric_new_mau',
    value: 'ampere_new_mau',
    txtkey: 'dbi_metric_new_mau',
    ableDateType: 'month',
  },
  {
    text: 'dbi_metric_retained_mau',
    value: 'ampere_retained_mau',
    txtkey: 'dbi_metric_retained_mau',
    ableDateType: 'month',
  },
  {
    text: 'dbi_metric_churned_mau',
    value: 'ampere_churned_mau',
    txtkey: 'dbi_metric_churned_mau',
    ableDateType: 'month',
  },
  { text: 'dbi_dau', value: 'ampere_dau', txtkey: 'dbi_dau', ableDateType: 'day' },
  {
    text: 'dbi_metric_new_dau',
    value: 'ampere_new_dau',
    txtkey: 'dbi_metric_new_dau',
    ableDateType: 'day',
  },
  {
    text: 'dbi_metric_avg_monthly_playtime',
    value: 'ampere_avg_monthly_playtime',
    txtkey: 'dbi_metric_avg_monthly_playtime',
    ableDateType: 'month',
  },
  {
    text: 'dbi_metric_acquisition_rate',
    value: 'ampere_acquisition_rate',
    txtkey: 'dbi_metric_acquisition_rate',
    ableDateType: 'month',
  },
  {
    text: 'dbi_metric_stickiness',
    value: 'ampere_stickiness',
    txtkey: 'dbi_metric_stickiness',
    ableDateType: 'month',
  },
  {
    text: 'dbi_metric_lifetime_player',
    value: 'ampere_lifetime_users',
    txtkey: 'dbi_metric_lifetime_player',
    ableDateType: 'month',
  },
  {
    text: 'dbi_metric_avg_dailly_playtime_hour',
    value: 'ampere_avg_dailly_playtime',
    txtkey: 'dbi_metric_avg_dailly_playtime_hour',
    ableDateType: 'day',
  },
  { text: 'D1', value: 'ampere_d1', txtkey: 'D1', ableDateType: 'day' },
  { text: 'D7', value: 'ampere_d7', txtkey: 'D7', ableDateType: 'day' },
  { text: 'D14', value: 'ampere_d14', txtkey: 'D14', ableDateType: 'day' },
  { text: 'D28', value: 'ampere_d28', txtkey: 'D28', ableDateType: 'day' },
  { text: 'D60', value: 'ampere_d60', txtkey: 'D60', ableDateType: 'day' },
  {
    text: 'dbi_metric_rolling_d1',
    value: 'ampere_rolling_d1',
    txtkey: 'dbi_metric_rolling_d1',
    ableDateType: 'day',
  },
  {
    text: 'dbi_metric_rolling_d7',
    value: 'ampere_rolling_d7',
    txtkey: 'dbi_metric_rolling_d7',
    ableDateType: 'day',
  },
  {
    text: 'dbi_metric_rolling_d14',
    value: 'ampere_rolling_d14',
    txtkey: 'dbi_metric_rolling_d14',
    ableDateType: 'day',
  },
  {
    text: 'dbi_metric_rolling_d28',
    value: 'ampere_rolling_d28',
    txtkey: 'dbi_metric_rolling_d28',
    ableDateType: 'day',
  },
  {
    text: 'dbi_metric_rolling_d60',
    value: 'ampere_rolling_d60',
    txtkey: 'dbi_metric_rolling_d60',
    ableDateType: 'day',
  },
];

export const GSD_METRICS = [
  {
    text: 'GSD',
    value: GSD_SOURCE_KEY,
    tableSource: tableDataSource.gsd,
    disabled: false,
    icon: GSD_SOURCE_KEY,
    messageKey: 'dbi_info_gsd_metrics_category_disabled_tips',
    messagekey: 'dbi_info_gsd_metrics_category_disabled_tips',
    message: InfoDoc.dbi_info_gsd_metrics_category_disabled_tips,
    messageCN: InfoDocCN.dbi_info_gsd_metrics_category_disabled_tips,
    children: [
      {
        // text: 'Digital Units',
        text: 'dbi_metric_gsd_digital_units',
        value: GSD_METRIC_KEY_MAP.DIGITAL_UNITS,
        textKey: 'dbi_metric_gsd_digital_units',
      },
      {
        // text: 'Physical Units',
        text: 'dbi_metric_gsd_physical_units',
        value: GSD_METRIC_KEY_MAP.PHYSICAL_UNITS,
        textKey: 'dbi_metric_gsd_physical_units',
      },
      {
        // text: 'Digital Revenue(€)',
        text: 'dbi_metric_gsd_digital_revenue_euro',
        value: GSD_METRIC_KEY_MAP.DIGITAL_REVENUE,
        textKey: 'dbi_metric_gsd_digital_revenue_euro',
      },
      {
        // text: 'Physical Revenue(€)',
        text: 'dbi_metric_gsd_physical_revenue_euro',
        value: GSD_METRIC_KEY_MAP.PHYSICAL_REVENUE,
        textKey: 'dbi_metric_gsd_physical_revenue_euro',
      },
    ],
  },
];
const NPD_METRICS = [
  {
    text: 'NPD',
    value: 'npd',
    tableSource: tableDataSource.npd,
    disabled: false,
    message: 'Physical revenue is available for US market and updated monthly.',
    messagekey: 'dbi_info_physical_monthly_only',
    children: [
      {
        // text: 'Physical Revenue($)',
        text: `dbi_metric_physical_revenue`,
        value: 'revenue',
      },
      {
        // text: 'Physical Units',
        text: `dbi_metric_physical_units`,
        value: 'physical_units',
      },
    ],
  },
];

const AMPERE_METRICS = [
  {
    text: 'Other Vendor',
    txtkey: 'Ampere',
    value: 'ampere',
    tableSource: tableDataSource.ampere,
    disabled: false,
    icon: 'ampere',
    message: 'Other Vendor are only available when the time granularity is month or day.',
    messagekey: 'dbi_info_other_vendor_disabled_tips',
    children: [
      { text: 'dbi_metric_mau', value: 'ampere_mau', txtkey: 'dbi_metric_mau' },
      {
        text: 'dbi_metric_previous_mau',
        value: 'ampere_previous_mau',
        txtkey: 'dbi_metric_previous_mau',
      },
      { text: 'dbi_metric_added_mau', value: 'ampere_added_mau', txtkey: 'dbi_metric_added_mau' },
      { text: 'dbi_metric_new_mau', value: 'ampere_new_mau', txtkey: 'dbi_metric_new_mau' },
      {
        text: 'dbi_metric_retained_mau',
        value: 'ampere_retained_mau',
        txtkey: 'dbi_metric_retained_mau',
      },
      {
        text: 'dbi_metric_churned_mau',
        value: 'ampere_churned_mau',
        txtkey: 'dbi_metric_churned_mau',
      },
      { text: 'dbi_dau', value: 'ampere_dau', txtkey: 'dbi_dau' },
      { text: 'dbi_metric_new_dau', value: 'ampere_new_dau', txtkey: 'dbi_metric_new_dau' },
      {
        text: 'dbi_metric_avg_monthly_playtime',
        value: 'ampere_avg_monthly_playtime',
        txtkey: 'dbi_metric_avg_monthly_playtime',
      },
      {
        text: 'dbi_metric_acquisition_rate',
        value: 'ampere_acquisition_rate',
        txtkey: 'dbi_metric_acquisition_rate',
      },
      {
        text: 'dbi_metric_stickiness',
        value: 'ampere_stickiness',
        txtkey: 'dbi_metric_stickiness',
      },
      {
        text: 'dbi_metric_lifetime_player',
        value: 'ampere_lifetime_users',
        txtkey: 'dbi_metric_lifetime_player',
      },
      {
        text: 'dbi_metric_avg_dailly_playtime_hour',
        value: 'ampere_avg_dailly_playtime',
        txtkey: 'dbi_metric_avg_dailly_playtime_hour',
      },
      // { text: 'D1', value: 'ampere_d1', txtkey: 'D1' },
      // { text: 'D7', value: 'ampere_d7', txtkey: 'D7' },
      // { text: 'D14', value: 'ampere_d14', txtkey: 'D14' },
      // { text: 'D28', value: 'ampere_d28', txtkey: 'D28' },
      // { text: 'D60', value: 'ampere_d60', txtkey: 'D60' },
      { text: 'dbi_metric_ampere_d1', value: 'ampere_d1', txtkey: 'dbi_metric_ampere_d1' },
      { text: 'dbi_metric_ampere_d7', value: 'ampere_d7', txtkey: 'dbi_metric_ampere_d7' },
      { text: 'dbi_metric_ampere_d14', value: 'ampere_d14', txtkey: 'dbi_metric_ampere_d14' },
      { text: 'dbi_metric_ampere_d28', value: 'ampere_d28', txtkey: 'dbi_metric_ampere_d28' },
      { text: 'dbi_metric_ampere_d60', value: 'ampere_d60', txtkey: 'dbi_metric_ampere_d60' },
      {
        text: 'dbi_metric_rolling_d1',
        value: 'ampere_rolling_d1',
        txtkey: 'dbi_metric_rolling_d1',
      },
      {
        text: 'dbi_metric_rolling_d7',
        value: 'ampere_rolling_d7',
        txtkey: 'dbi_metric_rolling_d7',
      },
      {
        text: 'dbi_metric_rolling_d14',
        value: 'ampere_rolling_d14',
        txtkey: 'dbi_metric_rolling_d14',
      },
      {
        text: 'dbi_metric_rolling_d28',
        value: 'ampere_rolling_d28',
        txtkey: 'dbi_metric_rolling_d28',
      },
      {
        text: 'dbi_metric_rolling_d60',
        value: 'ampere_rolling_d60',
        txtkey: 'dbi_metric_rolling_d60',
      },
    ],
  },
];

// echarts 图表指标筛选器数据源列表
export const ECHARTS_DATASOURCE_METRICS_PC = [
  {
    text: 'Steam',
    value: 'steam',
    tableSource: tableDataSource.steam,
    disabled: false,
    message: "Steam Metrics are only available by selecting 'Global' as market.",
    messagekey: 'dbi_info_steam_global_only',
    children: [
      {
        text: `dbi_metric_source_steam_pcu`,
        value: 'source_steam__pcu',
        icon: 'source_steam',
        tableSource: tableDataSource.source_steam,
      },
      {
        text: `dbi_metric_source_steam_acu`,
        value: 'source_steam__acu',
        icon: 'source_steam',
        tableSource: tableDataSource.source_steam,
      },
      {
        text: `dbi_metric_vgi_steam_followers`,
        value: 'steamfollowers',
        tableSource: tableDataSource.vginsights,
      },
    ],
  },
  {
    text: 'Mscience',
    value: 'Mscience',
    tableSource: tableDataSource.mscience,
    disabled: false,
    message: 'Mscience metrics are only available when US, UK, FR, DE, ES are selected.',
    messagekey: 'dbi_info_mscience_available_only',
    children: [
      {
        // text: 'Digital Revenue($)',
        text: `dbi_metric_digitalRevenue`,
        value: 'digitalRevenue',
      },
      {
        // text: 'Units',
        text: `dbi_metric_digital_units`,
        value: 'units',
      },
      {
        // text: 'Digital ARPPU($) (US only)',
        text: `dbi_metric_digitalARPPU`,
        value: 'digitalARPPU',
        message: 'Digital ARPPU($) is only available when US is selected.',
        messagekey: 'dbi_metric_digital_arpu_dollor_tips',
      },
      {
        // text: 'AST($)',
        text: `dbi_metric_ast`,
        value: 'ast',
      },
    ],
  },
  ...GSD_METRICS,
  ...NPD_METRICS,
  // {
  //   text: 'NPD',
  //   value: 'npd',
  //   metric: {
  //     text: 'Physical Revenue($)',
  //     value: 'revenue'
  //   },
  //   disabled: false,
  //   message: 'Physical revenue is available for US market and updated monthly.',
  //   messagekey: 'dbi_info_physical_monthly_only',
  //   children: []
  // },
  {
    text: 'Alinea Analytics',
    value: 'alinea',
    tableSource: 'alinea',
    disabled: false,
    message: 'Only global data.',
    messagekey: 'dbi_info_only_global_data',
    children: [
      {
        text: `dbi_metric_alinea_steam_est_revenue`,
        value: 'alinea__est_revenue',
        icon: 'alinea',
        tableSource: 'alinea',
      },
      {
        text: `dbi_metric_alinea_est_units`,
        value: 'alinea__est_units',
        icon: 'alinea',
        tableSource: 'alinea',
      },
      {
        text: 'dbi_metric_alinea_steam_pcu',
        value: 'alinea__pcu',
        icon: 'alinea',
        tableSource: 'alinea',
      },
      {
        text: 'dbi_metric_alinea_steam_acu',
        value: 'alinea__acu',
        icon: 'alinea',
        tableSource: 'alinea',
      },
      {
        text: `dbi_metric_alinea_steam_followers`,
        value: 'alinea__steamfollowers',
        icon: 'alinea',
        tableSource: 'alinea',
      },
      {
        text: `dbi_metric_alinea_est_price`,
        value: 'alinea__est_price',
        icon: 'alinea',
        tableSource: 'alinea',
      },
      {
        text: `dbi_metric_alinea_steam_reviews`,
        value: 'alinea__steamreviews',
        icon: 'alinea',
        tableSource: 'alinea',
      },
    ],
  },
  {
    text: 'Gamalytic',
    value: 'gamalytic',
    tableSource: tableDataSource.gamalytic,
    disabled: false,
    message: 'Only global data.',
    messagekey: 'dbi_info_only_global_data',
    children: [
      {
        text: `dbi_metric_gamalytic_steam_est_revenue`,
        value: 'gamalytic__est_revenue',
      },
      {
        text: `dbi_metric_gamalytic_est_units`,
        value: 'gamalytic__est_units',
      },
      {
        text: 'dbi_metric_gamalytic_steam_pcu',
        value: 'gamalytic__pcu',
        icon: 'gamalytic',
        tableSource: tableDataSource.gamalytic,
      },
      {
        text: 'dbi_metric_gamalytic_steam_acu',
        value: 'gamalytic__acu',
        icon: 'gamalytic',
        tableSource: tableDataSource.gamalytic,
      },
      {
        text: `dbi_metric_gamalytic_steam_followers`,
        value: 'gamalytic__steamfollowers',
        icon: 'gamalytic',
        tableSource: tableDataSource.gamalytic,
      },
      {
        text: `dbi_metric_gamalytic_est_price`,
        value: 'gamalytic__est_price',
      },
      {
        text: `dbi_metric_gamalytic_steam_reviews`,
        value: 'gamalytic__steamreviews',
        icon: 'gamalytic',
        tableSource: tableDataSource.gamalytic,
      },
    ],
  },
  {
    text: 'VG Insights',
    value: 'vginsights',
    tableSource: tableDataSource.vginsights,
    disabled: false,
    message: 'Only global data.',
    messagekey: 'dbi_info_only_global_data',
    children: [
      {
        text: `dbi_metric_vgi_steam_est_revenue`,
        value: 'est_revenue',
      },
      {
        text: `dbi_metric_vgi_steam_units`,
        value: 'est_units',
      },
      {
        text: 'dbi_metric_vgi_steam_pcu',
        value: 'pcu',
        icon: 'vginsights',
        tableSource: tableDataSource.steam,
      },
      {
        text: 'dbi_metric_vgi_steam_acu',
        value: 'acu',
        icon: 'vginsights',
        tableSource: tableDataSource.steam,
      },
      {
        text: `dbi_metric_vgi_steam_price`,
        value: 'est_price',
      },
      // {
      //   text: `dbi_metric_vgi_steam_followers`,
      //   value: 'steamfollowers',
      //   icon: 'steam',
      //   tableSource: tableDataSource.steam,
      // },
      {
        text: `dbi_metric_vgi_steam_reviews`,
        value: 'steamreviews',
        icon: 'vginsights',
        tableSource: tableDataSource.vginsights,
      },
    ],
  },
  {
    text: NewzooToDatabrain,
    value: 'newzoo',
    tableSource: tableDataSource.newzoo,
    disabled: false,
    message: InfoDoc.dbi_info_newzoo_month_updated,
    messagekey: 'dbi_info_newzoo_month_updated',
    children: newzooMetricsList,
  },
];

// echarts 图表指标筛选器数据源列表（pcConsole统一id榜单页）
const DATABRAIN_METRICS_SOURCE = {
  text: 'DataBrain',
  value: 'databrain',
  tableSource: tableDataSource.databrain,
  dataSourceIcon: 'databrainbluebg',
  disabled: false,
  messageKey: '',
  messagekey: '',
  message: '',
  messageCN: '',
  children: [
    {
      text: 'dbi_metric_total_revenue',
      value: 'databrain__total_revenue',
    },
    {
      text: 'dbi_metric_lifetime_total_revenue',
      value: 'databrain__lifetime_total_revenue',
    },
    {
      text: 'dbi_metric_base_game_sales_units',
      value: 'databrain__base_game_sales_units',
    },
    {
      text: 'dbi_metric_lifetime_base_game_sales_units',
      value: 'databrain__lifetime_base_game_sales_units',
    },
  ],
};

const ALINEA_CONSOLE_METRICS_CHILDREN = [
  {
    text: 'dbi_metric_alinea_ps_players_by_country',
    value: 'alinea__ps_players_by_country',
    tableSource: tableDataSource.alinea,
    icon: 'alinea',
  },
  {
    text: 'dbi_metric_alinea_ps_revenue',
    value: 'alinea__ps_est_revenue',
    tableSource: tableDataSource.alinea,
    icon: 'alinea',
  },
  {
    text: 'dbi_metric_alinea_ps_revenue_total',
    value: 'alinea__ps_est_cumulative_revenue',
    tableSource: tableDataSource.alinea,
    icon: 'alinea',
  },
  {
    text: 'dbi_metric_alinea_ps_units',
    value: 'alinea__ps_est_units',
    tableSource: tableDataSource.alinea,
    icon: 'alinea',
  },
  {
    text: 'dbi_metric_alinea_ps_units_total',
    value: 'alinea__ps_est_cumulative_units',
    tableSource: tableDataSource.alinea,
    icon: 'alinea',
  },
  {
    text: 'dbi_metric_alinea_ps_lifetime_players',
    value: 'alinea__ps_players',
    tableSource: tableDataSource.alinea,
    icon: 'alinea',
  },
  {
    text: 'dbi_metric_alinea_ps_plus_total_players',
    value: 'alinea__ps_players_total',
    tableSource: tableDataSource.alinea,
    icon: 'alinea',
  },
  {
    text: 'dbi_metric_alinea_ps_game_pass_players',
    value: 'alinea__ps_game_pass_players',
    tableSource: tableDataSource.alinea,
    icon: 'alinea',
  },
  {
    text: 'dbi_metric_alinea_ps_game_pass_players_total',
    value: 'alinea__ps_game_pass_players_total',
    tableSource: tableDataSource.alinea,
    icon: 'alinea',
  },
  {
    text: 'dbi_metric_alinea_ps_dau',
    value: 'alinea__ps_dau',
    tableSource: tableDataSource.alinea,
    icon: 'alinea',
    ableDateType: 'day',
    message: InfoDoc.dbi_info_alinea_dau_metric_disabled_tips,
    messageCN: InfoDocCN.dbi_info_alinea_dau_metric_disabled_tips,
  },
  {
    text: 'dbi_metric_alinea_ps_mau',
    value: 'alinea__ps_mau',
    tableSource: tableDataSource.alinea,
    icon: 'alinea',
    ableDateType: 'month',
    message: InfoDoc.dbi_info_alinea_mau_metric_disabled_tips,
    messageCN: InfoDocCN.dbi_info_alinea_mau_metric_disabled_tips,
  },
  {
    text: 'dbi_metric_alinea_ps_price',
    value: 'alinea__ps_price',
    tableSource: tableDataSource.alinea,
    icon: 'alinea',
  },
  {
    text: 'dbi_metric_alinea_xbox_revenue',
    value: 'alinea__xbox_est_revenue',
    tableSource: tableDataSource.alinea,
    icon: 'alinea',
  },
  {
    text: 'dbi_metric_alinea_xbox_revenue_total',
    value: 'alinea__xbox_est_cumulative_revenue',
    tableSource: tableDataSource.alinea,
    icon: 'alinea',
  },
  {
    text: 'dbi_metric_alinea_xbox_units',
    value: 'alinea__xbox_est_units',
    tableSource: tableDataSource.alinea,
    icon: 'alinea',
  },
  {
    text: 'dbi_metric_alinea_xbox_units_total',
    value: 'alinea__xbox_est_cumulative_units',
    tableSource: tableDataSource.alinea,
    icon: 'alinea',
  },
  {
    text: 'dbi_metric_alinea_xbox_players',
    value: 'alinea__xbox_players',
    tableSource: tableDataSource.alinea,
    icon: 'alinea',
  },
  {
    text: 'dbi_metric_alinea_xbox_game_pass_total_players',
    value: 'alinea__xbox_players_total',
    tableSource: tableDataSource.alinea,
    icon: 'alinea',
  },
  {
    text: 'dbi_metric_alinea_xbox_game_pass_players',
    value: 'alinea__xbox_game_pass_players',
    tableSource: tableDataSource.alinea,
    icon: 'alinea',
  },
  {
    text: 'dbi_metric_alinea_xbox_game_pass_players_total',
    value: 'alinea__xbox_game_pass_players_total',
    tableSource: tableDataSource.alinea,
    icon: 'alinea',
  },
  {
    text: 'dbi_metric_alinea_xbox_dau',
    value: 'alinea__xbox_dau',
    tableSource: tableDataSource.alinea,
    icon: 'alinea',
    ableDateType: 'day',
    message: InfoDoc.dbi_info_alinea_dau_metric_disabled_tips,
    messageCN: InfoDocCN.dbi_info_alinea_dau_metric_disabled_tips,
  },
  {
    text: 'dbi_metric_alinea_xbox_mau',
    value: 'alinea__xbox_mau',
    tableSource: tableDataSource.alinea,
    icon: 'alinea',
    ableDateType: 'month',
    message: InfoDoc.dbi_info_alinea_mau_metric_disabled_tips,
    messageCN: InfoDocCN.dbi_info_alinea_mau_metric_disabled_tips,
  },
  {
    text: 'dbi_metric_alinea_xbox_price',
    value: 'alinea__xbox_price',
    tableSource: tableDataSource.alinea,
    icon: 'alinea',
  },
];

const ALINEA_CONSOLE_METRICS_CHILDREN_FOR_DOWNLOAD =
  ALINEA_CONSOLE_METRICS_CHILDREN;

// PC&Console 详情页 Console Data 下载弹窗指标（仅 Alinea PS / Xbox）
export const ECHARTS_DATASOURCE_METRICS_COMBINE_CONSOLE_DATA = [
  {
    text: 'Alinea Analytics',
    value: 'alinea',
    tableSource: tableDataSource.alinea,
    disabled: false,
    message: 'Only global data.',
    messagekey: 'dbi_info_steam_data_metrics_category_disabled_tips',
    children: ALINEA_CONSOLE_METRICS_CHILDREN_FOR_DOWNLOAD,
  },
];

const ECHARTS_DATASOURCE_METRICS_PC_CONSOLE_BASE = [
  {
    text: 'Mscience',
    value: 'Mscience',
    tableSource: tableDataSource.mscience,
    disabled: false,
    messageKey: 'dbi_info_revenue_metrics_category_disabled_tips',
    messagekey: 'dbi_info_revenue_metrics_category_disabled_tips',
    message: InfoDoc.dbi_info_revenue_metrics_category_disabled_tips,
    messageCN: InfoDocCN.dbi_info_revenue_metrics_category_disabled_tips,
    children: [
      {
        // text: 'Digital Revenue($)',
        text: `dbi_metric_digitalRevenue`,
        value: 'digitalRevenue',
        disabled: false,
        messageKey: 'dbi_info_digital_revenue_metric_disabled_tips',
        messagekey: 'dbi_info_digital_revenue_metric_disabled_tips',
        message: InfoDoc.dbi_info_digital_revenue_metric_disabled_tips,
        messageCN: InfoDocCN.dbi_info_digital_revenue_metric_disabled_tips,
      },
      {
        // text: 'Units',
        text: `dbi_metric_digital_units`,
        value: 'units',
        disabled: false,
        messageKey: 'dbi_info_units_metric_disabled_tips',
        messagekey: 'dbi_info_units_metric_disabled_tips',
        message: InfoDoc.dbi_info_units_metric_disabled_tips,
        messageCN: InfoDocCN.dbi_info_units_metric_disabled_tips,
      },
      {
        // text: 'Digital ARPPU($) (US only)',
        text: `dbi_metric_digitalARPPU`,
        value: 'digitalARPPU',
        messageKey: 'dbi_info_digital_arppu_metric_disabled_tips',
        messagekey: 'dbi_info_digital_arppu_metric_disabled_tips',
        message: InfoDoc.dbi_info_digital_arppu_metric_disabled_tips,
        messageCN: InfoDocCN.dbi_info_digital_arppu_metric_disabled_tips,
      },
      {
        // text: 'AST($)',
        text: `dbi_metric_ast`,
        value: 'ast',
        disabled: false,
        messageKey: 'dbi_info_ast_metric_disabled_tips',
        messagekey: 'dbi_info_ast_metric_disabled_tips',
        message: InfoDoc.dbi_info_ast_metric_disabled_tips,
        messageCN: InfoDocCN.dbi_info_ast_metric_disabled_tips,
      },
      {
        text: 'dbi_metric_mscience_lifetime_digital_revenue',
        value: 'mscienceLifetimeDigitalRevenue',
        disabled: false,
        messageKey: 'dbi_info_mscience_lifetime_total_revenue',
        messagekey: 'dbi_info_mscience_lifetime_total_revenue',
        message: InfoDoc.dbi_info_mscience_lifetime_total_revenue,
        messageCN: InfoDocCN.dbi_info_mscience_lifetime_total_revenue,
      },
      {
        text: 'dbi_metric_mscience_lifetime_digital_units',
        value: 'mscienceLifetimeDigitalUnits',
        disabled: false,
        messageKey: 'dbi_info_mscience_lifetime_units_new',
        messagekey: 'dbi_info_mscience_lifetime_units_new',
        message: InfoDoc.dbi_info_mscience_lifetime_units_new,
        messageCN: InfoDocCN.dbi_info_mscience_lifetime_units_new,
      },
    ],
  },
  ...GSD_METRICS,
  {
    text: 'NPD',
    value: 'npd',
    tableSource: tableDataSource.npd,
    // metric: {
    //   text: 'Physical Revenue($)',
    //   value: 'revenue',
    // },
    disabled: false,
    messageKey: 'dbi_info_physical_revenue_metric_disabled_tips',
    messagekey: 'dbi_info_physical_revenue_metric_disabled_tips',
    message: InfoDoc.dbi_info_physical_revenue_metric_disabled_tips,
    messageCN: InfoDocCN.dbi_info_physical_revenue_metric_disabled_tips,
    children: [
      {
        // text: 'Physical Revenue($)',
        text: `dbi_metric_physical_revenue`,
        value: 'revenue',
      },
      {
        // text: 'Physical Units',
        text: `dbi_metric_physical_units`,
        value: 'physical_units',
      },
    ],
  },
  {
    text: 'Steam',
    value: 'steam',
    tableSource: tableDataSource.steam,
    disabled: false,
    messageKey: 'dbi_info_steam_data_metrics_category_disabled_tips',
    messagekey: 'dbi_info_steam_data_metrics_category_disabled_tips',
    message: InfoDoc.dbi_info_steam_data_metrics_category_disabled_tips,
    messageCN: InfoDocCN.dbi_info_steam_data_metrics_category_disabled_tips,
    children: [
      {
        text: `dbi_metric_source_steam_pcu`,
        value: 'source_steam__pcu',
        tableSource: tableDataSource.source_steam,
        icon: 'source_steam',
      },
      {
        text: `dbi_metric_source_steam_acu`,
        value: 'source_steam__acu',
        tableSource: tableDataSource.source_steam,
        icon: 'source_steam',
      },
      {
        text: `dbi_metric_vgi_steam_followers`,
        value: 'steamfollowers',
        tableSource: tableDataSource.vginsights,
        icon: 'steam',
      },
    ],
  },
  {
    text: 'Alinea Analytics',
    value: 'alinea',
    tableSource: tableDataSource.alinea,
    disabled: false,
    message: 'Only global data.',
    messagekey: 'dbi_info_steam_data_metrics_category_disabled_tips',
    children: [
      {
        text: 'dbi_metric_alinea_steam_est_revenue',
        value: 'alinea__est_revenue',
        tableSource: tableDataSource.alinea,
        icon: 'alinea',
      },
      {
        text: 'dbi_metric_alinea_jptb_cumulative_revenue_trends',
        value: 'alinea__est_cumulative_revenue',
        tableSource: tableDataSource.alinea,
        icon: 'alinea',
      },
      {
        text: 'dbi_metric_alinea_est_units',
        value: 'alinea__est_units',
        tableSource: tableDataSource.alinea,
        icon: 'alinea',
      },
      {
        text: 'dbi_metric_alinea_steam_cumulative_units',
        value: 'alinea__est_cumulative_units',
        tableSource: tableDataSource.alinea,
        icon: 'alinea',
      },
      {
        text: 'dbi_metric_alinea_steam_pcu',
        value: 'alinea__pcu',
        tableSource: tableDataSource.alinea,
        icon: 'alinea',
      },
      {
        text: 'dbi_metric_alinea_steam_acu',
        value: 'alinea__acu',
        tableSource: tableDataSource.alinea,
        icon: 'alinea',
      },
      {
        text: 'dbi_metric_alinea_mau',
        value: 'alinea__mau',
        tableSource: tableDataSource.alinea,
        icon: 'alinea',
        ableDateType: 'month',
        message: InfoDoc.dbi_info_alinea_mau_metric_disabled_tips,
        messageCN: InfoDocCN.dbi_info_alinea_mau_metric_disabled_tips,
      },
      {
        text: 'dbi_metric_alinea_dau',
        value: 'alinea__dau',
        tableSource: tableDataSource.alinea,
        icon: 'alinea',
        ableDateType: 'day',
        message: InfoDoc.dbi_info_alinea_dau_metric_disabled_tips,
        messageCN: InfoDocCN.dbi_info_alinea_dau_metric_disabled_tips,
      },
      {
        text: 'dbi_metric_alinea_playtime_steam',
        value: 'alinea__playtime',
        tableSource: tableDataSource.alinea,
        icon: 'alinea',
      },
      {
        text: 'dbi_metric_alinea_steam_players',
        value: 'alinea__players',
        tableSource: tableDataSource.alinea,
        icon: 'alinea',
      },
      {
        text: 'dbi_metric_alinea_steam_total_players',
        value: 'alinea__players_total',
        tableSource: tableDataSource.alinea,
        icon: 'alinea',
      },
      {
        text: 'dbi_metric_alinea_steam_followers',
        value: 'alinea__steamfollowers',
        tableSource: tableDataSource.alinea,
        icon: 'alinea',
      },
      {
        text: 'dbi_metric_alinea_steam_daily_wishlist',
        value: 'alinea__wishlists',
        tableSource: tableDataSource.alinea,
        icon: 'alinea',
      },
      {
        text: 'dbi_metric_alinea_steam_lifetime_wishlist',
        value: 'alinea__wishlists_total',
        tableSource: tableDataSource.alinea,
        icon: 'alinea',
      },
      {
        text: 'dbi_metric_alinea_est_price',
        value: 'alinea__est_price',
        tableSource: tableDataSource.alinea,
        icon: 'alinea',
      },
      {
        text: 'dbi_metric_alinea_steam_reviews',
        value: 'alinea__steamreviews',
        tableSource: tableDataSource.alinea,
        icon: 'alinea',
      },
      {
        text: 'dbi_metric_alinea_steam_total_reviews',
        value: 'alinea__cumulative_reviews',
        tableSource: tableDataSource.alinea,
        icon: 'alinea',
      },
      {
        text: 'dbi_metric_alinea_steam_positive_reviews',
        value: 'alinea__positive',
        tableSource: tableDataSource.alinea,
        icon: 'alinea',
      },
      {
        text: 'dbi_metric_alinea_steam_total_positive_reviews',
        value: 'alinea__cumulative_positive',
        tableSource: tableDataSource.alinea,
        icon: 'alinea',
      },
      ...ALINEA_CONSOLE_METRICS_CHILDREN_FOR_DOWNLOAD,
    ],
  },
  {
    text: 'Gamalytic',
    value: 'gamalytic',
    tableSource: tableDataSource.gamalytic,
    disabled: false,
    message: 'Only global data.',
    messagekey: 'dbi_info_steam_data_metrics_category_disabled_tips',
    children: [
      {
        text: 'dbi_metric_gamalytic_steam_est_revenue',
        value: 'gamalytic__est_revenue',
      },
      {
        text: 'dbi_metric_gamalytic_jptb_cumulative_revenue_trends',
        value: 'gamalytic__est_cumulative_revenue',
      },
      {
        text: 'dbi_metric_gamalytic_est_units',
        value: 'gamalytic__est_units',
      },
      {
        text: 'dbi_metric_gamalytic_steam_cumulative_units',
        value: 'gamalytic__est_cumulative_units',
      },
      {
        text: 'dbi_metric_gamalytic_steam_pcu',
        value: 'gamalytic__pcu',
        tableSource: tableDataSource.steam,
        icon: 'gamalytic',
      },
      {
        text: 'dbi_metric_gamalytic_steam_acu',
        value: 'gamalytic__acu',
        tableSource: tableDataSource.steam,
        icon: 'gamalytic',
      },
      {
        text: 'dbi_metric_gamalytic_steam_followers',
        value: 'gamalytic__steamfollowers',
        icon: 'gamalytic',
      },
      {
        text: 'dbi_metric_gamalytic_steam_daily_wishlist',
        value: 'gamalytic__wishlists',
      },
      {
        text: 'dbi_metric_gamalytic_steam_lifetime_wishlist',
        value: 'gamalytic__wishlists_total',
      },
      {
        text: 'dbi_metric_gamalytic_est_price',
        value: 'gamalytic__est_price',
      },
      {
        text: 'dbi_metric_gamalytic_steam_reviews',
        value: 'gamalytic__steamreviews',
        icon: 'gamalytic',
      },
      {
        text: 'dbi_metric_gamalytic_steam_total_reviews',
        value: 'gamalytic__cumulative_reviews',
        tableSource: tableDataSource.gamalytic,
        icon: 'gamalytic',
      },
    ],
  },
  {
    text: 'VG Insights',
    value: 'vginsights',
    tableSource: tableDataSource.vginsights,
    disabled: false,
    messageKey: 'dbi_info_vgi_metrics_category_disabled_tips',
    messagekey: 'dbi_info_vgi_metrics_category_disabled_tips',
    message: InfoDoc.dbi_info_vgi_metrics_category_disabled_tips,
    messageCN: InfoDocCN.dbi_info_vgi_metrics_category_disabled_tips,
    children: [
      {
        text: `dbi_metric_vgi_steam_est_revenue`,
        value: 'est_revenue',
      },
      {
        text: `dbi_metric_vgi_steam_cumulative_revenue`,
        value: 'est_cumulative_revenue',
      },
      {
        text: `dbi_metric_vgi_steam_units`,
        value: 'est_units',
      },
      {
        text: `dbi_metric_vgi_steam_cumulative_units`,
        value: 'est_cumulative_units',
      },
      {
        text: 'dbi_metric_vgi_steam_pcu',
        value: 'pcu',
        tableSource: tableDataSource.vginsights,
        icon: 'vginsights',
      },
      {
        text: 'dbi_metric_vgi_steam_acu',
        value: 'acu',
        tableSource: tableDataSource.vginsights,
        icon: 'vginsights',
      },
      {
        text: 'dbi_metric_vgi_steam_daily_wishlist',
        value: 'wishlists',
      },
      {
        text: `dbi_metric_vgi_steam_lifetime_wishlist`,
        value: 'wishlists_total',
      },
      {
        text: `dbi_metric_vgi_steam_price`,
        value: 'est_price',
      },
      {
        text: `dbi_metric_vgi_steam_reviews`,
        value: 'steamreviews',
        tableSource: tableDataSource.vginsights,
        icon: 'vginsights',
      },
    ],
  },
  {
    text: 'Other Vendor',
    value: 'ampere',
    tableSource: tableDataSource.ampere,
    disabled: false,
    messageKey: 'dbi_info_ampere_other_vendor_category_disabled_tips',
    message: InfoDoc.dbi_info_ampere_other_vendor_category_disabled_tips,
    messageCN: InfoDocCN.dbi_info_ampere_other_vendor_category_disabled_tips,
    children: ampereMetricsList,
  },
  // {
  //   text: 'Japan Sales',
  //   value: 'famitsu',
  //   tableSource: tableDataSource.famitsu,
  //   disabled: false,
  //   messageKey: 'dbi_info_console_japan_sales_metrics_category_disabled_tips',
  //   messagekey: 'dbi_info_console_japan_sales_metrics_category_disabled_tips',
  //   message: InfoDoc.dbi_info_console_japan_sales_metrics_category_disabled_tips,
  //   messageCN: InfoDocCN.dbi_info_console_japan_sales_metrics_category_disabled_tips,
  //   children: [
  //     {
  //       // text: 'Sales of selected time',
  //       text: `dbi_metric_jpseg_sales`,
  //       value: 'famitsu_sales',
  //     },
  //     {
  //       // text: 'Price',
  //       text: `dbi_top_price$`,
  //       value: 'famitsu_price',
  //     },
  //     {
  //       // text: 'Revenue of selected time',
  //       text: `dbi_metric_jpseg_revenue`,
  //       value: 'famitsu_revenue',
  //     },
  //     {
  //       // text: 'Cumulative Sales of the latest week',
  //       text: `dbi_metric_jptb_cumulative_sales`,
  //       value: 'famitsu_cumulative_sales',
  //     },
  //     {
  //       // text: 'Cumulative Revenue of the latest week',
  //       text: `dbi_metric_jptb_cumulative_revenue`,
  //       value: 'famitsu_cumulative_revenue',
  //     },
  //   ],
  // },
  {
    text: NewzooToDatabrain,
    value: 'newzoo',
    tableSource: tableDataSource.newzoo,
    disabled: false,
    messageKey: 'dbi_info_newzoo_metrics_category_disabled_tips',
    message: InfoDoc.dbi_info_newzoo_metrics_category_disabled_tips,
    messageCN: InfoDocCN.dbi_info_newzoo_metrics_category_disabled_tips,
    children: newzooMetricsList,
  },
];

export const ECHARTS_DATASOURCE_METRICS_PC_CONSOLE_WITH_DATABRAIN = [
  DATABRAIN_METRICS_SOURCE,
  ...ECHARTS_DATASOURCE_METRICS_PC_CONSOLE_BASE,
];

export const ECHARTS_DATASOURCE_METRICS_PC_CONSOLE = ECHARTS_DATASOURCE_METRICS_PC_CONSOLE_BASE;

// echarts 图表指标筛选器数据源列表--following
export const ECHARTS_DATASOURCE_METRICS_FOLLOWING = [
  {
    id: '1',
    title: 'Active Users',
    img: 'Appannie',
  },
  {
    id: '2',
    title: 'Revenue',
    img: 'Appannie',
  },
  {
    id: '3',
    title: 'Downloads',
    img: 'Appannie',
  },
  {
    id: '4',
    title: 'Active Users',
    img: 'Sensortower',
  },
  {
    id: '5',
    title: 'Revenue',
    img: 'Sensortower',
  },
  {
    id: '6',
    title: 'Downloads',
    img: 'Sensortower',
  },
  {
    id: '7',
    title: 'Hours Watched',
    img: 'Hatchet',
  },
  {
    id: '8',
    title: 'Peak CCV',
    img: 'Hatchet',
  },
];

// echarts 图表指标筛选器数据源列表--pc-PCU榜单
export const ECHARTS_DATASOURCE_METRICS_PC_PCU = [
  {
    children: [],
    disabled: false,
    message: '',
    metric: {
      text: 'dbi_metric_source_steam_pcu',
      value: 'source_steam__pcu',
    },
    text: 'dbi_metric_source_steam_pcu',
    value: 'source_steam__pcu',
    icon: 'source_steam',
  },
  {
    children: [],
    disabled: false,
    message: '',
    metric: {
      text: 'dbi_metric_source_steam_acu',
      value: 'source_steam__acu',
    },
    text: 'dbi_metric_source_steam_acu',
    value: 'source_steam__acu',
    icon: 'source_steam',
  },
  {
    children: [],
    disabled: false,
    message: '',
    metric: {
      text: 'dbi_metric_vgi_steam_followers',
      value: 'steamfollowers',
    },
    text: 'dbi_metric_vgi_steam_followers',
    value: 'steamfollowers',
    icon: 'steam',
  },
  {
    children: [],
    disabled: false,
    message: '',
    metric: {
      text: 'dbi_metric_alinea_steam_reviews',
      value: 'alinea__steamreviews',
    },
    text: 'dbi_metric_alinea_steam_reviews',
    value: 'alinea__steamreviews',
    icon: 'alinea',
  },
];

// echarts 图表指标筛选器数据源列表--pcDigitalRevenue榜单
export const ECHARTS_DATASOURCE_METRICS_PC_DIGITALREV = [
  {
    children: [],
    disabled: false,
    ifNoImg: true,
    message: '',
    metric: {
      text: 'dbi_metric_digitalRevenue',
      value: 'digitalRevenue',
    },
    text: 'dbi_metric_digitalRevenue',
    value: 'digitalRevenue',
  },
  {
    children: [],
    disabled: false,
    ifNoImg: true,
    message: '',
    metric: {
      text: 'dbi_metric_units',
      value: 'units',
    },
    text: 'dbi_metric_units',
    value: 'units',
  },
  {
    children: [],
    disabled: true,
    ifNoImg: true,
    message: 'Digital ARPPU($) is only available when US is selected.',
    messagekey: 'dbi_metric_digital_arpu_dollor_tips',
    metric: {
      text: 'dbi_metric_digitalARPPU',
      value: 'digitalARPPU',
    },
    text: 'dbi_metric_digitalARPPU',
    value: 'digitalARPPU',
  },
  {
    children: [],
    disabled: false,
    ifNoImg: true,
    message: '',
    metric: {
      text: 'dbi_calc_metric_avg_ast',
      value: 'ast',
    },
    text: 'dbi_calc_metric_avg_ast',
    value: 'ast',
  },
];

// echarts 图表指标筛选器数据源列表--pcRevenue榜单
export const ECHARTS_DATASOURCE_METRICS_PC_REVENUE = [
  {
    children: [],
    disabled: false,
    ifNoImg: true,
    message: '',
    metric: {
      text: 'dbi_metric_physical_revenue',
      value: 'revenue',
    },
    text: 'dbi_metric_physical_revenue',
    value: 'revenue',
  },
  {
    children: [],
    disabled: false,
    ifNoImg: true,
    message: '',
    metric: {
      text: 'dbi_metric_physical_units',
      value: 'physical_units',
    },
    text: 'dbi_metric_physical_units',
    value: 'physical_units',
  },
];

// echarts 图表指标筛选器数据源列表--pcMAU榜单
export const ECHARTS_DATASOURCE_METRICS_PC_MAU = [
  {
    children: [],
    disabled: false,
    ifNoImg: true,
    message: '',
    metric: {
      text: 'dbi_mau',
      value: 'mau',
    },
    text: 'dbi_mau',
    value: 'mau',
  },
  {
    children: [],
    disabled: false,
    ifNoImg: true,
    message: '',
    metric: {
      text: 'dbi_metric_acquisition',
      value: 'acquisition',
    },
    text: 'dbi_metric_acquisition',
    value: 'acquisition',
  },
];

// echarts 图表指标筛选器数据源列表--pcLIFETIMEPLAYERS榜单
export const ECHARTS_DATASOURCE_METRICS_PC_LIFETIMEPLAYERS = [
  {
    children: [],
    disabled: false,
    ifNoImg: true,
    message: '',
    metric: {
      text: 'dbi_lifetime_players',
      value: 'lifetime_player',
    },
    text: 'dbi_lifetime_players',
    value: 'lifetime_player',
  },
];

// echarts 图表指标筛选器数据源列表--pc游戏详情
export const ECHARTS_DATASOURCE_METRICS_PC_DETAIL = [
  {
    text: 'PCU',
    value: 'steam',
    tableSource: tableDataSource.steam,
    disabled: false,
    message: "Steam Metrics are only available by selecting 'Global' as market.",
    messagekey: 'dbi_info_steam_global_only',
    children: [
      {
        text: 'dbi_metric_source_steam_pcu',
        value: 'source_steam__pcu',
        icon: 'source_steam',
        tableSource: tableDataSource.source_steam,
      },
      {
        text: 'dbi_metric_source_steam_acu',
        value: 'source_steam__acu',
        icon: 'source_steam',
        tableSource: tableDataSource.source_steam,
      },
      {
        // text: 'Steam Followers',
        text: `dbi_metric_vgi_steam_followers`,
        value: 'steamfollowers',
        icon: 'steam',
        tableSource: tableDataSource.vginsights,
      },
      {
        text: 'dbi_metric_alinea_steam_pcu',
        value: 'alinea__pcu',
        icon: 'alinea',
        tableSource: tableDataSource.alinea,
      },
      {
        text: 'dbi_metric_alinea_steam_acu',
        value: 'alinea__acu',
        icon: 'alinea',
        tableSource: tableDataSource.alinea,
      },
      {
        text: `dbi_metric_alinea_steam_followers`,
        value: 'alinea__steamfollowers',
        icon: 'alinea',
        tableSource: tableDataSource.alinea,
      },
      {
        text: `dbi_metric_alinea_steam_reviews`,
        value: 'alinea__steamreviews',
        icon: 'alinea',
        tableSource: tableDataSource.alinea,
      },
      {
        // text: 'Gamalytic Steam PCU',
        text: 'dbi_metric_gamalytic_steam_pcu',
        value: 'gamalytic__pcu',
        icon: 'gamalytic',
        tableSource: tableDataSource.gamalytic,
      },
      {
        // text: 'Gamalytic Steam ACU',
        text: 'dbi_metric_gamalytic_steam_acu',
        value: 'gamalytic__acu',
        icon: 'gamalytic',
        tableSource: tableDataSource.gamalytic,
      },
      {
        // text: 'Gamalytic Steam Followers',
        text: `dbi_metric_gamalytic_steam_followers`,
        value: 'gamalytic__steamfollowers',
        icon: 'gamalytic',
        tableSource: tableDataSource.gamalytic,
      },
      {
        // text: 'Gamalytic Steam Reviews',
        text: `dbi_metric_gamalytic_steam_reviews`,
        value: 'gamalytic__steamreviews',
        icon: 'gamalytic',
        tableSource: tableDataSource.gamalytic,
      },
      {
        // text: 'PCU',
        text: 'dbi_metric_vgi_steam_pcu',
        value: 'pcu',
        icon: 'vginsights',
        tableSource: tableDataSource.steam,
      },
      {
        // text: 'ACU',
        text: 'dbi_metric_vgi_steam_acu',
        value: 'acu',
        icon: 'vginsights',
        tableSource: tableDataSource.steam,
      },
      {
        // text: 'Steam Reviews',
        text: `dbi_metric_vgi_steam_reviews`,
        value: 'steamreviews',
        icon: 'vginsights',
        tableSource: tableDataSource.vginsights,
      },
    ],
  },
  {
    text: 'Mscience',
    value: 'Mscience',
    tableSource: tableDataSource.mscience,
    disabled: false,
    message: 'Mscience metrics are only available when US, UK, FR, DE, ES are selected.',
    messagekey: 'dbi_info_mscience_available_only',
    children: [
      {
        // text: 'Digital Revenue($)',
        text: `dbi_metric_digitalRevenue`,
        value: 'digitalRevenue',
      },
      {
        // text: 'Units',
        text: `dbi_metric_digital_units`,
        value: 'units',
      },
      {
        // text: 'Digital ARPPU($) (US only)',
        text: `dbi_metric_digitalARPPU`,
        value: 'digitalARPPU',
        message: 'Digital ARPPU($) is only available when US is selected.',
        messagekey: 'dbi_metric_digital_arpu_dollor_tips',
      },
      {
        // text: 'AST($)',
        text: `dbi_metric_ast`,
        value: 'ast',
      },
    ],
  },
  ...GSD_METRICS,
  ...NPD_METRICS,
  // {
  //   text: 'Physical Revenue',
  //   value: 'npd',
  //   metric: {
  //     text: 'Physical Revenue($)',
  //     value: 'revenue'
  //   },
  //   disabled: false,
  //   message: 'Physical revenue is available for US market and updated monthly.',
  //   messagekey: 'dbi_info_physical_monthly_only',
  //   children: []
  // },
  {
    // text: 'User Engagement',
    text: 'No-Update',
    value: 'newzoo',
    tableSource: tableDataSource.newzoo,
    disabled: false,
    message: InfoDoc.dbi_info_newzoo_month_updated,
    messagekey: 'dbi_info_newzoo_month_updated',
    children: [
      {
        // text: 'MAU',
        text: `dbi_metric_mau`,
        value: 'mau',
      },
      {
        // text: 'Player Share',
        text: `dbi_metric_player_share`,
        value: 'player_share',
      },
      {
        // text: 'MAU Growth',
        text: `dbi_metric_mau_growth`,
        value: 'mau_growth',
      },
      {
        // text: 'MAU - New',
        text: `dbi_metric_mau_new`,
        value: 'mau_new',
      },
      {
        // text: 'MAU - Returning',
        text: `dbi_metric_mau_returning`,
        value: 'mau_returning',
      },
      {
        // text: 'Lifetime Players',
        text: `dbi_metric_lifetime_player`,
        value: 'lifetime_player',
      },
      {
        // text: 'Time Spent 0 - 1 hrs',
        text: `dbi_metric_time_spent_0H`,
        value: 'time_spent_0H',
      },
      {
        // text: 'Time Spent 1 - 5 hrs',
        text: `dbi_metric_time_spent_1H`,
        value: 'time_spent_1H',
      },
      {
        // text: 'Time Spent 5 - 10 hrs',
        text: `dbi_metric_time_spent_5H`,
        value: 'time_spent_5H',
      },
      {
        // text: 'Time Spent 10 - 25 hrs',
        text: `dbi_metric_time_spent_10H`,
        value: 'time_spent_10H',
      },
      {
        // text: 'Time Spent 25 - 50 hrs',
        text: `dbi_metric_time_spent_25H`,
        value: 'time_spent_25H',
      },
      {
        // text: 'Time Spent > 50 hrs',
        text: `dbi_metric_time_spent_50H`,
        value: 'time_spent_50H',
      },
      {
        // text: 'Avg Daily Playtime (mins)',
        text: `dbi_metric_avg_daily_playtime`,
        value: 'avg_daily_playtime',
      },
      {
        // text: 'Avg Daily Sessions',
        text: `dbi_metric_avg_daily_sessions`,
        value: 'avg_daily_sessions',
      },
      {
        // text: 'Avg Playtime Per Session (mins)',
        text: `dbi_metric_avg_playtime_per_session`,
        value: 'avg_playtime_per_session',
      },
      {
        // text: 'Avg Monthly Playtime (hours)',
        text: `dbi_metric_avg_monthly_playtime`,
        value: 'avg_monthly_playtime',
      },
      {
        // text: 'Avg Monthly Sessions',
        text: `dbi_metric_avg_monthly_sessions`,
        value: 'avg_monthly_sessions',
      },
      {
        // text: 'Avg Days Played',
        text: `dbi_metric_avg_days_played`,
        value: 'avg_days_played',
      },
      {
        // text: 'Stickiness',
        text: `dbi_metric_stickiness`,
        value: 'stickiness',
      },
      {
        // text: 'Total Hours',
        text: `dbi_metric_total_hours`,
        value: 'total_hours',
      },
      {
        // text: 'Churn %',
        text: `dbi_metric_churn`,
        value: 'churn',
      },
      {
        // text: 'Acquisition %',
        text: `dbi_metric_acquisition`,
        value: 'acquisition',
      },
      {
        // text: 'Retention D1',
        text: `dbi_retention_d1`,
        value: 'retention_d1',
      },
      {
        // text: 'Retention D2',
        text: `dbi_retention_d2`,
        value: 'retention_d2',
      },
      {
        // text: 'Retention D4',
        text: `dbi_retention_d4`,
        value: 'retention_d4',
      },
      {
        // text: 'Retention D7',
        text: `dbi_retention_d7`,
        value: 'retention_d7',
      },
      {
        // text: 'Retention D14',
        text: `dbi_retention_d14`,
        value: 'retention_d14',
      },
      {
        // text: 'Retention D28',
        text: `dbi_retention_d28`,
        value: 'retention_d28',
      },
    ],
  },
];

// echarts 图表指标筛选器数据源列表--pc游戏详情-streaming
export const LIVE_STREAMING_METRICS = [
  {
    text: 'Streaming',
    value: 'stream',
    disabled: false,
    message: 'Only global data.',
    messagekey: 'dbi_info_only_global_data',
    children: [
      {
        // text: 'Hours Watched',
        text: 'dbh_metric_hourswatched',
        value: 'hoursWatched',
      },
      {
        // text: 'Airtime',
        text: 'dbi_metric_airtime',
        value: 'airtime',
      },
      {
        // text: 'Peak CCV',
        text: 'dbi_metric_peakccv',
        value: 'peackCCV',
        message: '',
      },
      {
        // text: 'Avg CCV',
        text: 'dbi_metric_avgccv',
        value: 'avgCCV',
      },
    ],
  },
];

// echarts 图表指标筛选器数据源列表--pc游戏详情-steamsales
export const STEAMSALES_METRICS = [
  {
    text: 'Steam Sales',
    value: 'vginsights',
    tableSource: tableDataSource.vginsights,
    disabled: false,
    message: 'Only global data.',
    messagekey: 'dbi_info_steam_data_metrics_category_disabled_tips',
    children: [
      {
        // text: 'Premium Revenue($)',
        text: `dbi_metric_vgi_steam_est_revenue`,
        value: 'est_revenue',
      },
      {
        // text: 'Cumulative Revenue($)',
        text: `dbi_metric_vgi_steam_cumulative_revenue`,
        value: 'est_cumulative_revenue',
      },
      {
        // text: 'Units',
        text: `dbi_metric_vgi_steam_units`,
        value: 'est_units',
      },
      {
        // text: 'Cumulative Units',
        text: `dbi_metric_vgi_steam_cumulative_units`,
        value: 'est_cumulative_units',
      },
      {
        // text: 'Avg. Playtime(mins)',
        text: `dbi_metric_vgi_steam_playtime`,
        value: 'playtime',
      },
      {
        // text: 'Players by country',
        text: `dbi_metric_vgi_players_by_country`,
        value: 'players_by_country',
      },
      // PC detail 应该先不加这个指标, PC&Cosole 单独新增处理
      // {
      //   text: `dbi_metric_vgi_daily_wishlist`,
      //   value: 'wishlists',
      // },
      // {
      //   text: `dbi_metric_vgi_lifetime_wishlist`,
      //   value: 'wishlists_total',
      // },
      {
        // text: 'Price($)',
        text: `dbi_metric_vgi_steam_price`,
        value: 'est_price',
      },
      {
        // text: 'Weighted Price($)',
        text: `dbi_metric_vgi_weighted_price`,
        value: 'weighted_price',
      },
      {
        // text: 'Lifetime weighted price($)',
        text: `dbi_metric_vgi_lifetime_weighted_price`,
        value: 'lifetime_weighted_price',
      },
    ],
  },
];

// echarts 图表指标筛选器数据源列表--pc游戏详情-steamsales
export const STEAMSALES_METRICS_OLD = [
  {
    text: 'Steam Sales',
    value: 'vginsights',
    tableSource: tableDataSource.vginsights,
    disabled: false,
    message: 'Only global data.',
    messagekey: 'dbi_info_steam_data_metrics_category_disabled_tips',
    icon: 'steam',
    children: [
      {
        text: 'dbi_metric_alinea_steam_est_revenue',
        value: 'alinea__est_revenue',
        tableSource: tableDataSource.alinea,
        icon: 'alinea',
      },
      {
        text: 'dbi_metric_alinea_steam_cumulative_revenue',
        value: 'alinea__est_cumulative_revenue',
        tableSource: tableDataSource.alinea,
        icon: 'alinea',
      },
      {
        text: 'dbi_metric_alinea_est_units',
        value: 'alinea__est_units',
        tableSource: tableDataSource.alinea,
        icon: 'alinea',
      },
      {
        text: 'dbi_metric_alinea_steam_cumulative_units',
        value: 'alinea__est_cumulative_units',
        tableSource: tableDataSource.alinea,
        icon: 'alinea',
      },
      {
        text: 'dbi_metric_alinea_est_price',
        value: 'alinea__est_price',
        tableSource: tableDataSource.alinea,
        icon: 'alinea',
      },
      {
        text: 'dbi_metric_alinea_weighted_price',
        value: 'alinea__weighted_price',
        tableSource: tableDataSource.alinea,
        icon: 'alinea',
      },
      {
        text: 'dbi_metric_alinea_lifetime_weighted_price_trends',
        value: 'alinea__lifetime_weighted_price',
        tableSource: tableDataSource.alinea,
        icon: 'alinea',
      },
      {
        text: 'dbi_metric_alinea_players_by_country',
        value: 'alinea__players_by_country',
        tableSource: tableDataSource.alinea,
        icon: 'alinea',
      },
      {
        text: 'dbi_metric_alinea_wishlists_by_country',
        value: 'alinea__wishlists_by_country',
        tableSource: tableDataSource.alinea,
        icon: 'alinea',
      },
      {
        text: 'dbi_metric_alinea_playtime_steam',
        value: 'alinea__playtime',
        tableSource: tableDataSource.alinea,
        icon: 'alinea',
      },
      {
        // Gamalytic - Premium Revenue($)
        text: 'dbi_metric_gamalytic_steam_est_revenue',
        value: 'gamalytic__est_revenue',
        tableSource: tableDataSource.gamalytic,
        icon: 'gamalytic',
      },
      {
        // Gamalytic - Cumulative Revenue($)
        text: 'dbi_metric_gamalytic_jptb_cumulative_revenue_trends',
        value: 'gamalytic__est_cumulative_revenue',
        tableSource: tableDataSource.gamalytic,
        icon: 'gamalytic',
      },
      {
        // Gamalytic - Units
        text: 'dbi_metric_gamalytic_est_units',
        value: 'gamalytic__est_units',
        tableSource: tableDataSource.gamalytic,
        icon: 'gamalytic',
      },
      {
        // Gamalytic - Cumulative Units
        text: 'dbi_metric_gamalytic_steam_cumulative_units',
        value: 'gamalytic__est_cumulative_units',
        tableSource: tableDataSource.gamalytic,
        icon: 'gamalytic',
      },
      // PC detail 应该先不加这个指标, PC&Cosole 单独新增处理
      // {
      //   text: `dbi_metric_daily_wishlist`,
      //   value: 'wishlists',
      // },
      // {
      //   text: `dbi_metric_lifetime_wishlist`,
      //   value: 'wishlists_total',
      // },
      {
        // Gamalytic - Price($)
        text: 'dbi_metric_gamalytic_est_price',
        value: 'gamalytic__est_price',
        tableSource: tableDataSource.gamalytic,
        icon: 'gamalytic',
      },
      {
        // Gamalytic - Weighted Price($)
        text: 'dbi_metric_gamalytic_weighted_price',
        value: 'gamalytic__weighted_price',
        tableSource: tableDataSource.gamalytic,
        icon: 'gamalytic',
      },
      {
        // Gamalytic - Lifetime weighted price($)
        text: 'dbi_metric_gamalytic_lifetime_weighted_price_trends',
        value: 'gamalytic__lifetime_weighted_price',
        tableSource: tableDataSource.gamalytic,
        icon: 'gamalytic',
      },
      {
        // Gamalytic - Players by country
        text: 'dbi_metric_gamalytic_players_by_country',
        value: 'gamalytic__players_by_country',
        tableSource: tableDataSource.gamalytic,
        icon: 'gamalytic',
      },
      {
        // Gamalytic - Avg. Playtime(mins)
        text: 'dbi_metric_gamalytic_playtime_steam',
        value: 'gamalytic__playtime',
        tableSource: tableDataSource.gamalytic,
        icon: 'gamalytic',
      },
      // {
      //   // Gamalytic - Total followers
      //   text: 'dbi_metric_gamalytic_followers',
      //   value: 'gamalytic__steamfollowers',
      //   tableSource: tableDataSource.gamalytic,
      //   icon: 'gamalytic',
      // },
      {
        // text: 'Premium Revenue($)',
        text: `dbi_metric_vgi_steam_est_revenue`,
        value: 'est_revenue',
      },
      {
        // text: 'Cumulative Revenue($)',
        text: `dbi_metric_vgi_steam_cumulative_revenue`,
        value: 'est_cumulative_revenue',
      },
      {
        // text: 'Units',
        text: `dbi_metric_vgi_steam_units`,
        value: 'est_units',
      },
      {
        // text: 'Cumulative Units',
        text: `dbi_metric_vgi_steam_cumulative_units`,
        value: 'est_cumulative_units',
      },
      {
        // text: 'Price($)',
        text: `dbi_metric_vgi_steam_price`,
        value: 'est_price',
      },
      {
        // text: 'Weighted Price($)',
        text: `dbi_metric_vgi_weighted_price`,
        value: 'weighted_price',
      },
      {
        // text: 'Lifetime weighted price($)',
        text: `dbi_metric_vgi_lifetime_weighted_price`,
        value: 'lifetime_weighted_price',
      },
      {
        // text: 'Players by country',
        text: `dbi_metric_vgi_players_by_country`,
        value: 'players_by_country',
      },
      {
        // text: 'Avg. Playtime(mins)',
        text: `dbi_metric_vgi_steam_playtime`,
        value: 'playtime',
      },
      // {
      //   // text: 'Total followers',
      //   text: `dbi_metric_vgi_followers`,
      //   value: 'followers',
      // },
    ],
  },
];

// PC&Cosole steam sales metrics 在 STEAMSALES_METRICS 基础上新增 wishlists、wishlists_total 指标
const getCombineSteamsalesMetricsChildren = () => {
  const metrics: any[] = (STEAMSALES_METRICS?.[0]?.children?.slice() || []) as any[];

  const priceIndex = metrics.findIndex((item) => item?.value === 'est_price');
  const insertIndex = priceIndex >= 0 ? priceIndex : metrics.length;

  metrics.splice(
    insertIndex,
    0,
    {
      text: `dbi_metric_vgi_steam_daily_wishlist`,
      value: 'wishlists',
      tableSource: tableDataSource.vginsights,
    },
    {
      text: `dbi_metric_vgi_steam_lifetime_wishlist`,
      value: 'wishlists_total',
      tableSource: tableDataSource.vginsights,
    },
  );

  // 确保所有指标都使用 vginsights 作为 tableSource（除了PCU和ACU在父级单独定义）
  return metrics.map((item) => ({
    ...item,
    tableSource: tableDataSource.vginsights,
  }));
};

// Multi-dimension compare download modal:
// Gamalytic should expose the same 2nd-level metrics as "VGI Steam Data" but with gamalytic-prefixed metric keys.
const getCombineGamalyticSteamsalesMetricsChildren = () => {
  const vgiChildren: any[] = getCombineSteamsalesMetricsChildren() || [];
  const valueMap: Record<string, string> = {
    est_revenue: 'gamalytic__est_revenue',
    est_cumulative_revenue: 'gamalytic__est_cumulative_revenue',
    est_units: 'gamalytic__est_units',
    est_cumulative_units: 'gamalytic__est_cumulative_units',
    wishlists: 'gamalytic__wishlists',
    wishlists_total: 'gamalytic__wishlists_total',
    est_price: 'gamalytic__est_price',
    weighted_price: 'gamalytic__weighted_price',
    lifetime_weighted_price: 'gamalytic__lifetime_weighted_price',
    players_by_country: 'gamalytic__players_by_country',
    playtime: 'gamalytic__playtime',
  };
  const textMap: Record<string, string> = {
    est_revenue: 'dbi_metric_gamalytic_steam_est_revenue',
    est_cumulative_revenue: 'dbi_metric_gamalytic_jptb_cumulative_revenue_trends',
    est_units: 'dbi_metric_gamalytic_est_units',
    est_cumulative_units: 'dbi_metric_gamalytic_steam_cumulative_units',
    wishlists: 'dbi_metric_gamalytic_steam_daily_wishlist',
    wishlists_total: 'dbi_metric_gamalytic_steam_lifetime_wishlist',
    est_price: 'dbi_metric_gamalytic_est_price',
    weighted_price: 'dbi_metric_gamalytic_weighted_price',
    lifetime_weighted_price: 'dbi_metric_gamalytic_lifetime_weighted_price_trends',
    players_by_country: 'dbi_metric_gamalytic_players_by_country',
    playtime: 'dbi_metric_gamalytic_playtime_steam',
  };

  return vgiChildren.map((item) => {
    const rawValue = item?.value;
    return {
      ...item,
      text: typeof rawValue === 'string' ? textMap[rawValue] || item?.text : item?.text,
      value: typeof rawValue === 'string' ? valueMap[rawValue] || rawValue : rawValue,
      tableSource: tableDataSource.gamalytic,
    };
  });
};

// echarts 图表指标筛选器数据源列表--pcConsole联合游戏-source_steam
export const COMBINE_SOURCE_STEAM_METRICS = [{
  text: 'Steam',
  value: 'source_steam',
  tableSource: tableDataSource.source_steam,
  disabled: false,
  children: [
    { text: 'dbi_metric_source_steam_pcu', value: 'source_steam__pcu', tableSource: tableDataSource.source_steam },
    { text: 'dbi_metric_source_steam_acu', value: 'source_steam__acu', tableSource: tableDataSource.source_steam },
    { text: 'dbi_metric_vgi_steam_followers', value: 'steamfollowers', icon: 'steam', tableSource: tableDataSource.steam },
  ]
}]
// echarts 图表指标筛选器数据源列表--pcConsole联合游戏-gamalytic
export const COMBINE_GAMALYTIC_METRICS = [
  {
    text: 'Gamalytic',
    value: 'gamalytic',
    tableSource: tableDataSource.gamalytic,
    disabled: false,
    message: 'Only global data.',
    messagekey: 'dbi_info_steam_data_metrics_category_disabled_tips',
    children: [
      // Revenue
      { text: 'dbi_metric_gamalytic_steam_est_revenue', value: 'gamalytic__est_revenue', tableSource: tableDataSource.gamalytic },
      { text: 'dbi_metric_gamalytic_jptb_cumulative_revenue_trends', value: 'gamalytic__est_cumulative_revenue', tableSource: tableDataSource.gamalytic },
      // Units
      { text: 'dbi_metric_gamalytic_est_units', value: 'gamalytic__est_units', tableSource: tableDataSource.gamalytic },
      { text: 'dbi_metric_gamalytic_steam_cumulative_units', value: 'gamalytic__est_cumulative_units', tableSource: tableDataSource.gamalytic },
      // PCU/ACU
      { text: 'dbi_metric_gamalytic_steam_pcu', value: 'gamalytic__pcu', tableSource: tableDataSource.gamalytic },
      { text: 'dbi_metric_gamalytic_steam_acu', value: 'gamalytic__acu', tableSource: tableDataSource.gamalytic },
      // Engagement
      { text: 'dbi_metric_gamalytic_playtime_steam', value: 'gamalytic__playtime', tableSource: tableDataSource.gamalytic },
      {
        text: 'dbi_metric_gamalytic_players_by_country',
        value: 'gamalytic__players_by_country',
        tableSource: tableDataSource.gamalytic,
      },
      // Followers
      { text: 'dbi_metric_gamalytic_steam_followers', value: 'gamalytic__steamfollowers', tableSource: tableDataSource.gamalytic },
      // Wishlist
      { text: 'dbi_metric_gamalytic_steam_daily_wishlist', value: 'gamalytic__wishlists', tableSource: tableDataSource.gamalytic },
      { text: 'dbi_metric_gamalytic_steam_lifetime_wishlist', value: 'gamalytic__wishlists_total', tableSource: tableDataSource.gamalytic },
      // Price
      { text: 'dbi_metric_gamalytic_est_price', value: 'gamalytic__est_price', tableSource: tableDataSource.gamalytic },
      { text: 'dbi_metric_gamalytic_lifetime_weighted_price_trends', value: 'gamalytic__lifetime_weighted_price', tableSource: tableDataSource.gamalytic },
      // Reviews
      { text: 'dbi_metric_gamalytic_steam_reviews', value: 'gamalytic__steamreviews', tableSource: tableDataSource.gamalytic },
      { text: 'dbi_metric_gamalytic_steam_total_reviews', value: 'gamalytic__cumulative_reviews', tableSource: tableDataSource.gamalytic },
    ],
  },
];

// Multi-dimension compare download modal: Merge Gamalytic and VGI into "Steam Data".
// Gamalytic metrics are placed above VGI metrics.
export const COMBINE_GAMALYTIC_STEAM_DATA_METRICS_COMPARE = [
  {
    ...STEAMSALES_METRICS[0],
    text: 'Steam Data',
    value: 'vginsights',
    icon: 'steam',
    children: [
      // Gamalytic metrics (above VGI metrics)
      // PCU/ACU
      { text: 'dbi_metric_gamalytic_steam_pcu', value: 'gamalytic__pcu', icon: 'gamalytic', tableSource: tableDataSource.steam },
      { text: 'dbi_metric_gamalytic_steam_acu', value: 'gamalytic__acu', icon: 'gamalytic', tableSource: tableDataSource.steam },
      // Followers/Reviews
      { text: 'dbi_metric_gamalytic_steam_followers', value: 'gamalytic__steamfollowers', icon: 'gamalytic', tableSource: tableDataSource.steam },
      { text: 'dbi_metric_gamalytic_steam_reviews', value: 'gamalytic__steamreviews', icon: 'gamalytic', tableSource: tableDataSource.steam },
      { text: 'dbi_metric_gamalytic_steam_total_reviews', value: 'gamalytic__cumulative_reviews', icon: 'gamalytic', tableSource: tableDataSource.steam },
      ...getCombineGamalyticSteamsalesMetricsChildren(),
      // VGI metrics (below Gamalytic metrics)
      {
        text: 'dbi_metric_vgi_steam_pcu',
        value: 'pcu',
        icon: 'vginsights',
        tableSource: tableDataSource.steam,
      },
      {
        text: 'dbi_metric_vgi_steam_acu',
        value: 'acu',
        icon: 'vginsights',
        tableSource: tableDataSource.steam,
      },
      // {
      //   text: `dbi_metric_vgi_steam_followers`,
      //   value: 'steamfollowers',
      //   icon: 'steam',
      //   tableSource: tableDataSource.steam,
      // },
      {
        text: `dbi_metric_vgi_steam_reviews`,
        value: 'steamreviews',
        icon: 'vginsights',
        tableSource: tableDataSource.steam,
      },
      ...getCombineSteamsalesMetricsChildren(),
    ],
  },
];

export const COMBINE_ALINEA_METRICS = [
  {
    text: 'Alinea Analytics',
    value: 'alinea',
    tableSource: tableDataSource.alinea,
    disabled: false,
    message: 'Only global data.',
    messagekey: 'dbi_info_steam_data_metrics_category_disabled_tips',
    children: [
      // Revenue
      { text: 'dbi_metric_alinea_steam_est_revenue', value: 'alinea__est_revenue', icon: 'alinea', tableSource: tableDataSource.alinea },
      { text: 'dbi_metric_alinea_jptb_cumulative_revenue_trends', value: 'alinea__est_cumulative_revenue', icon: 'alinea', tableSource: tableDataSource.alinea },
      // Units
      { text: 'dbi_metric_alinea_est_units', value: 'alinea__est_units', icon: 'alinea', tableSource: tableDataSource.alinea },
      { text: 'dbi_metric_alinea_steam_cumulative_units', value: 'alinea__est_cumulative_units', icon: 'alinea', tableSource: tableDataSource.alinea },
      // PCU/ACU
      { text: 'dbi_metric_alinea_steam_pcu', value: 'alinea__pcu', icon: 'alinea', tableSource: tableDataSource.alinea },
      { text: 'dbi_metric_alinea_steam_acu', value: 'alinea__acu', icon: 'alinea', tableSource: tableDataSource.alinea },
      // Active Users
      {
        text: 'dbi_metric_alinea_mau',
        value: 'alinea__mau',
        icon: 'alinea',
        tableSource: tableDataSource.alinea,
        ableDateType: 'month',
        message: InfoDoc.dbi_info_alinea_mau_metric_disabled_tips,
        messageCN: InfoDocCN.dbi_info_alinea_mau_metric_disabled_tips,
      },
      {
        text: 'dbi_metric_alinea_dau',
        value: 'alinea__dau',
        icon: 'alinea',
        tableSource: tableDataSource.alinea,
        ableDateType: 'day',
        message: InfoDoc.dbi_info_alinea_dau_metric_disabled_tips,
        messageCN: InfoDocCN.dbi_info_alinea_dau_metric_disabled_tips,
      },
      // Playtime
      { text: 'dbi_metric_alinea_playtime_steam', value: 'alinea__playtime', icon: 'alinea', tableSource: tableDataSource.alinea },
      // Players
      { text: 'dbi_metric_alinea_steam_players', value: 'alinea__players', icon: 'alinea', tableSource: tableDataSource.alinea },
      { text: 'dbi_metric_alinea_steam_total_players', value: 'alinea__players_total', icon: 'alinea', tableSource: tableDataSource.alinea },
      {
        text: 'dbi_metric_alinea_players_by_country',
        value: 'alinea__players_by_country',
        icon: 'alinea',
        tableSource: tableDataSource.alinea,
      },
      // Followers
      { text: 'dbi_metric_alinea_steam_followers', value: 'alinea__steamfollowers', icon: 'alinea', tableSource: tableDataSource.alinea },
      // Wishlist
      { text: 'dbi_metric_alinea_steam_daily_wishlist', value: 'alinea__wishlists', icon: 'alinea', tableSource: tableDataSource.alinea },
      { text: 'dbi_metric_alinea_steam_lifetime_wishlist', value: 'alinea__wishlists_total', icon: 'alinea', tableSource: tableDataSource.alinea },
      // Price
      { text: 'dbi_metric_alinea_est_price', value: 'alinea__est_price', icon: 'alinea', tableSource: tableDataSource.alinea },
      { text: 'dbi_metric_alinea_lifetime_weighted_price_trends', value: 'alinea__lifetime_weighted_price', icon: 'alinea', tableSource: tableDataSource.alinea },
      // Reviews
      { text: 'dbi_metric_alinea_steam_reviews', value: 'alinea__steamreviews', icon: 'alinea', tableSource: tableDataSource.alinea },
      { text: 'dbi_metric_alinea_steam_total_reviews', value: 'alinea__cumulative_reviews', icon: 'alinea', tableSource: tableDataSource.alinea },
      { text: 'dbi_metric_alinea_steam_positive_reviews', value: 'alinea__positive', icon: 'alinea', tableSource: tableDataSource.alinea },
      { text: 'dbi_metric_alinea_steam_total_positive_reviews', value: 'alinea__cumulative_positive', icon: 'alinea', tableSource: tableDataSource.alinea },
      ...ALINEA_CONSOLE_METRICS_CHILDREN_FOR_DOWNLOAD,
    ],
  },
];

// echarts 图表指标筛选器数据源列表--pcConsole联合游戏详情-steamsales
export const COMBINE_STEAMSALES_METRICS = [
  {
    ...STEAMSALES_METRICS[0],
    text: 'VGI Steam Data',
    icon: 'vginsights',
    children: [
      {
        text: `dbi_metric_vgi_steam_est_revenue`,
        value: 'est_revenue',
        icon: 'vginsights',
        tableSource: tableDataSource.vginsights,
      },
      {
        text: `dbi_metric_vgi_steam_cumulative_revenue`,
        value: 'est_cumulative_revenue',
        icon: 'vginsights',
        tableSource: tableDataSource.vginsights,
      },
      {
        text: `dbi_metric_vgi_steam_units`,
        value: 'est_units',
        icon: 'vginsights',
        tableSource: tableDataSource.vginsights,
      },
      {
        text: `dbi_metric_vgi_steam_cumulative_units`,
        value: 'est_cumulative_units',
        icon: 'vginsights',
        tableSource: tableDataSource.vginsights,
      },
      {
        text: 'dbi_metric_vgi_steam_pcu',
        value: 'pcu',
        icon: 'vginsights',
        tableSource: tableDataSource.steam,
      },
      {
        text: 'dbi_metric_vgi_steam_acu',
        value: 'acu',
        icon: 'vginsights',
        tableSource: tableDataSource.steam,
      },
      // Engagement
      {
        text: `dbi_metric_vgi_steam_playtime`,
        value: 'playtime',
        icon: 'vginsights',
        tableSource: tableDataSource.vginsights,
      },
      {
        text: `dbi_metric_vgi_players_by_country`,
        value: 'players_by_country',
        icon: 'vginsights',
        tableSource: tableDataSource.vginsights,
      },
      // {
      //   text: `dbi_metric_vgi_steam_followers`,
      //   value: 'steamfollowers',
      //   icon: 'vginsights',
      //   tableSource: tableDataSource.steam,
      // },
      {
        text: `dbi_metric_vgi_steam_daily_wishlist`,
        value: 'wishlists',
        icon: 'vginsights',
        tableSource: tableDataSource.vginsights,
      },
      {
        text: `dbi_metric_vgi_steam_lifetime_wishlist`,
        value: 'wishlists_total',
        icon: 'vginsights',
        tableSource: tableDataSource.vginsights,
      },
      {
        text: `dbi_metric_vgi_steam_price`,
        value: 'est_price',
        icon: 'vginsights',
        tableSource: tableDataSource.vginsights,
      },
      {
        text: `dbi_metric_vgi_lifetime_weighted_price`,
        value: 'lifetime_weighted_price',
        icon: 'vginsights',
        tableSource: tableDataSource.vginsights,
      },
      {
        text: `dbi_metric_vgi_steam_reviews`,
        value: 'steamreviews',
        icon: 'vginsights',
        tableSource: tableDataSource.steam,
      },
    ],
  },
];

// 目前看只用于下载的下拉列表
export const ECHARTS_DATASOURCE_METRICS_CONSOLE = [
  {
    text: 'Mscience',
    value: 'Mscience',
    tableSource: tableDataSource.mscience,
    disabled: false,
    message: 'Mscience metrics are only available when US, UK, FR, DE, ES are selected.',
    messagekey: 'dbi_info_mscience_available_only',
    children: [
      {
        // text: 'Digital Revenue($)',
        text: `dbi_metric_digitalRevenue`,
        value: 'digitalRevenue',
      },
      {
        // text: 'Units',
        text: `dbi_metric_digital_units`,
        value: 'units',
      },
      {
        // text: 'Digital ARPPU($) (US only)',
        text: `dbi_metric_digitalARPPU`,
        value: 'digitalARPPU',
        message: 'Digital ARPPU($) is only available when US is selected.',
        messagekey: 'dbi_metric_digital_arpu_dollor_tips',
      },
      {
        // text: 'AST($)',
        text: `dbi_metric_ast`,
        value: 'ast',
      },
    ],
  },
  ...GSD_METRICS,
  ...NPD_METRICS,
  // {
  //   text: 'Physical Revenue',
  //   value: 'npd',
  //   metric: {
  //     text: 'Physical Revenue($)',
  //     value: 'revenue'
  //   },
  //   disabled: false,
  //   message: 'Physical revenue is available for US market and updated monthly.',
  //   messagekey: 'dbi_info_physical_monthly_only',
  //   children: []
  // },
  {
    // text: 'User Engagement',
    text: 'No-Update',
    value: 'newzoo',
    tableSource: tableDataSource.newzoo,
    disabled: false,
    message: InfoDoc.dbi_info_newzoo_month_updated,
    messagekey: 'dbi_info_newzoo_month_updated',
    children: newzooMetricsList,
  },
];

const DATABRAIN_KPITRENDS_DOWNLOAD_METRICS = {
  text: 'DataBrain',
  value: 'databrain',
  tableSource: tableDataSource.databrain,
  disabled: false,
  children: [
    {
      text: 'dbi_metric_total_revenue',
      value: 'databrain__total_revenue',
      tableSource: tableDataSource.databrain,
    },
    {
      text: 'dbi_metric_lifetime_total_revenue',
      value: 'databrain__lifetime_total_revenue',
      tableSource: tableDataSource.databrain,
    },
    {
      text: 'dbi_metric_base_game_sales_units',
      value: 'databrain__base_game_sales_units',
      tableSource: tableDataSource.databrain,
    },
    {
      text: 'dbi_metric_lifetime_base_game_sales_units',
      value: 'databrain__lifetime_base_game_sales_units',
      tableSource: tableDataSource.databrain,
    },
  ],
};

const MSCIENCE_KPITRENDS_DOWNLOAD_METRICS = {
  text: 'Mscience',
  value: 'Mscience',
  tableSource: tableDataSource.mscience,
  disabled: false,
  message: 'Mscience metrics are only available when US, UK, FR, DE, ES are selected.',
  messagekey: 'dbi_info_mscience_available_only',
  children: [
    { text: 'dbi_digital_revenue_$', value: 'digitalRevenue' },
    {
      text: 'dbi_metric_mscience_lifetime_digital_revenue',
      value: 'mscienceLifetimeDigitalRevenue',
    },
    { text: 'Units', value: 'units' },
    {
      text: 'dbi_metric_mscience_lifetime_digital_units',
      value: 'mscienceLifetimeDigitalUnits',
    },
    {
      text: 'dbi_digital_revenue_$_only_us',
      value: 'digitalARPPU',
      message: 'Digital ARPPU($) is only available when US is selected.',
      messagekey: 'dbi_metric_digital_arpu_dollor_tips',
    },
    { text: 'dbi_metric_ast_$', value: 'ast' },
  ],
};

const NEWZOO_KPITRENDS_DOWNLOAD_METRICS = {
  text: 'No-Update',
  value: 'newzoo',
  tableSource: tableDataSource.newzoo,
  disabled: false,
  message: InfoDoc.dbi_info_newzoo_month_updated,
  messagekey: 'dbi_info_newzoo_month_updated',
  children: newzooMetricsList,
};

// No-Update 是独立的数据源配置；通过命名常量复用，避免依赖 Console 列表的末项位置。
const PC_CONSOLE_NO_UPDATE_METRICS = NEWZOO_KPITRENDS_DOWNLOAD_METRICS;

// KPI Trends 下载弹窗数据源顺序与 PC&Console 榜单一致；No Update 固定在 Streaming 后。
export const ECHARTS_DATASOURCE_METRICS_KPITRENDS = orderPCConsoleSourceGroups([
  MSCIENCE_KPITRENDS_DOWNLOAD_METRICS,
  ...COMBINE_SOURCE_STEAM_METRICS,
  ...COMBINE_ALINEA_METRICS,
  ...COMBINE_GAMALYTIC_METRICS,
  ...COMBINE_STEAMSALES_METRICS,
  ...GSD_METRICS,
  ...NPD_METRICS,
  ...AMPERE_METRICS,
]);

// Famitsu is temporarily unavailable in Intelligence pages.
// Kept for rollback — do not re-spread into download metric selectors until restored.
export const JAPAN_SALES_METRICS = [
  {
    text: 'Famitsu',
    value: 'famitsu',
    tableSource: tableDataSource.famitsu,
    disabled: false,
    message: '',
    messagekey: 'dbi_info_console_japan_sales_metrics_category_disabled_tips',
    children: [
      {
        // text: 'Sales of selected time',
        text: `dbi_metric_jpseg_sales`,
        value: 'week_sales',
      },
      {
        // text: 'Revenue of selected time',
        text: `dbi_metric_jpseg_revenue`,
        value: 'revenue',
      },
      {
        // text: 'Cumulative Sales',
        text: `dbi_metric_jpseg_cumulative_sales`,
        value: 'total_sales',
      },
      {
        // text: 'Cumulative Revenue',
        text: `dbi_metric_jpseg_cumulative_revenue`,
        value: 'total_revenue',
      },
      {
        // text: 'Price',
        text: `dbi_metric_jpseg_price`,
        value: 'usd_price',
      },
    ],
  },
];

export const DIGITALREVENUE_DEVICE = [
  {
    text: 'NPD',
    textCN: 'NPD',
    value: 'npd',
    icon: NpdIcon,
    message: 'Physical revenue is available for US market and updated monthly.',
    bubbleContent: InfoDoc.dbi_info_physical_monthly_only,
    bubbleContentCN: InfoDocCN.dbi_info_physical_monthly_only,
    children: [
      { text: 'PC', textCN: 'PC', value: 'npd###pc' },
      { text: 'PlayStation 4', textCN: 'PlayStation 4', value: 'npd###PlayStation 4' },
      { text: 'PlayStation 5', textCN: 'PlayStation 5', value: 'npd###PlayStation 5' },
      { text: 'Xbox One', textCN: 'Xbox One', value: 'npd###Xbox One' },
      { text: 'Xbox Series X|S', textCN: 'Xbox Series X|S', value: 'npd###Xbox Series X|S' },
      { text: 'Nintendo Wii U', textCN: 'Nintendo Wii U', value: 'npd###Nintendo Wii U' },
      { text: 'Nintendo Switch', textCN: 'Nintendo Switch', value: 'npd###Nintendo Switch' },
    ],
  },
  {
    text: 'Mscience',
    textCN: 'Mscience',
    value: 'mscience',
    icon: MscienceIcon,
    bubbleContent: InfoDoc.dbi_info_revenue_metrics_category_disabled_tips,
    bubbleContentCN: InfoDocCN.dbi_info_revenue_metrics_category_disabled_tips,
    children: [
      { text: 'PC', textCN: 'PC', value: 'mscience###pc' },
      { text: 'PlayStation', textCN: 'PlayStation', value: 'mscience###PlayStation' },
      { text: 'Xbox', textCN: 'Xbox', value: 'mscience###Xbox' },
      { text: 'Nintendo', textCN: 'Nintendo', value: 'mscience###Nintendo' },
    ],
  },
  {
    text: 'Steam Sales',
    textCN: 'Steam Sales',
    value: 'vginsights',
    icon: SteamIcon,
    bubbleContent: InfoDoc.dbi_info_only_global_data,
    bubbleContentCN: InfoDocCN.dbi_info_only_global_data,
    children: [{ text: 'PC', textCN: 'PC', value: 'vginsights###pc' }],
  },
  // Famitsu is temporarily unavailable in Intelligence pages.
  // {
  //   text: 'Famitsu',
  //   textCN: 'Famitsu',
  //   value: 'famitsu',
  //   icon: FamitsuIcon,
  //   bubbleContent: InfoDoc.dbi_info_console_japan_sales_metrics_category_disabled_tips,
  //   bubbleContentCN: InfoDocCN.dbi_info_console_japan_sales_metrics_category_disabled_tips,
  //   children: [
  //     { text: 'PlayStation 4', textCN: 'PlayStation 4', value: 'famitsu###PS4' },
  //     { text: 'PlayStation 5', textCN: 'PlayStation 5', value: 'famitsu###PS5' },
  //     { text: 'Nintendo Switch', textCN: 'Nintendo Switch', value: 'famitsu###Switch' },
  //   ],
  // },
  {
    text: NewzooToDatabrain,
    textCN: NewzooToDatabrain,
    value: 'newzoo',
    icon: NewzooIcon,
    bubbleContent: InfoDoc.dbi_info_newzoo_metrics_category_disabled_tips,
    bubbleContentCN: InfoDocCN.dbi_info_newzoo_metrics_category_disabled_tips,
    children: [
      { text: 'PC', textCN: 'PC', value: 'newzoo###pc' },
      { text: 'PlayStation 4', textCN: 'PlayStation 4', value: 'newzoo###PlayStation 4' },
      { text: 'PlayStation 5', textCN: 'PlayStation 5', value: 'newzoo###PlayStation 5' },
      { text: 'Xbox One', textCN: 'Xbox One', value: 'newzoo###Xbox One' },
      { text: 'Xbox Series X|S', textCN: 'Xbox Series X|S', value: 'newzoo###Xbox Series X|S' },
    ],
  },
];

export const DEVICE_Locale_Language = {
  en: {
    region_title: 'Data Source',
    market_title: 'Device',
    search: 'Search',
    select_all: 'Select All',
    clear_all: 'Clear All',
    button_region: 'Data Source',
    button_market: 'Device',
    search_none: 'No result found',
    country_no_data: 'No result found',
  },
  cn: {
    region_title: '数据源',
    market_title: '设备',
    search: '搜索',
    select_all: '全选',
    clear_all: '清空',
    button_region: '数据源',
    button_market: '设备',
    search_none: '无匹配项',
    country_no_data: '无匹配项',
  },
};
export const OPTIONS_METRICS = [
  {
    text: 'Opinions',
    value: 'opinions',
    disabled: false,
    children: [
      { text: 'Mentions', value: 'Mentions' },
      { text: 'Brand Health', value: 'Brand Health' },
      { text: 'Steam All reviews', value: 'Steam All reviews' },
      { text: 'Steam All reviews Positive%', value: 'Steam All reviews Positive%' },
      { text: 'Steam Added Reviews', value: 'Steam Added Reviews' },
      { text: 'Steam Added Positive%', value: 'Steam Added Positive%' },
    ],
  },
];
// pc游戏详情页下载 指标配置
export const ECHARTS_DATASOURCE_METRICS_PC_DETAILS = [
  ...ECHARTS_DATASOURCE_METRICS_PC_DETAIL,
  ...LIVE_STREAMING_METRICS,
  ...STEAMSALES_METRICS_OLD,
];

// console游戏详情页下载 指标配置
export const ECHARTS_DATASOURCE_METRICS_CONSOLE_DETAILS = [
  ...ECHARTS_DATASOURCE_METRICS_CONSOLE,
  ...LIVE_STREAMING_METRICS,
  // Famitsu is temporarily unavailable in Intelligence pages.
  // ...JAPAN_SALES_METRICS,
];

// pcConsole游戏详情页下载 指标配置
export const ECHARTS_DATASOURCE_METRICS_COMBINE_DETAILS = [
  ...ECHARTS_DATASOURCE_METRICS_CONSOLE.slice(0, 1),
  ...COMBINE_STEAMSALES_METRICS,
  ...COMBINE_ALINEA_METRICS,
  ...ECHARTS_DATASOURCE_METRICS_CONSOLE.slice(1),
  ...LIVE_STREAMING_METRICS,
  // Famitsu is temporarily unavailable in Intelligence pages.
  // ...JAPAN_SALES_METRICS,
];
export const ECHARTS_DATASOURCE_METRICS_COMBINE_DETAILS_COMPARE = orderPCConsoleSourceGroups([
  DATABRAIN_KPITRENDS_DOWNLOAD_METRICS,
  ...ECHARTS_DATASOURCE_METRICS_PC_CONSOLE.slice(0, 1),
  ...COMBINE_SOURCE_STEAM_METRICS,
  ...COMBINE_ALINEA_METRICS,
  ...COMBINE_GAMALYTIC_METRICS,
  ...COMBINE_STEAMSALES_METRICS,
  ...GSD_METRICS,
  ...NPD_METRICS,
  ...AMPERE_METRICS,
  ...LIVE_STREAMING_METRICS,
  PC_CONSOLE_NO_UPDATE_METRICS,
  // Famitsu is temporarily unavailable in Intelligence pages.
  // ...JAPAN_SALES_METRICS,
  ...OPTIONS_METRICS,
]);

// pcConsole游戏详情页-KPITrends下载 指标配置
export const ECHARTS_DATASOURCE_METRICS_COMBINE_KPITRENDS = orderPCConsoleSourceGroups([
  DATABRAIN_KPITRENDS_DOWNLOAD_METRICS,
  ...ECHARTS_DATASOURCE_METRICS_KPITRENDS,
  ...LIVE_STREAMING_METRICS,
  // Famitsu is temporarily unavailable in Intelligence pages.
  // ...JAPAN_SALES_METRICS,
  NEWZOO_KPITRENDS_DOWNLOAD_METRICS,
]);

// 兼容历史调用方；实际配置统一复用上面的 KPI Trends 配置，避免两套列表后续产生分叉。
export const ECHARTS_DATASOURCE_METRICS_COMBINE_KPITRENDS_NEW =
  ECHARTS_DATASOURCE_METRICS_COMBINE_KPITRENDS;

export const ECHARTS_DATASOURCE_METRICS_MAP: { [key: string]: any[] } = {
  combinePCConsoleMetricsTable: ECHARTS_DATASOURCE_METRICS_PC_CONSOLE,
  combinePCConsoleDataBrainCalibration: ECHARTS_DATASOURCE_METRICS_PC_CONSOLE_WITH_DATABRAIN,
  pcMetricsTable: ECHARTS_DATASOURCE_METRICS_PC,
  pcPCU: ECHARTS_DATASOURCE_METRICS_PC_PCU,
  pcDigitalRevenue: ECHARTS_DATASOURCE_METRICS_PC_DIGITALREV,
  pcPhysicalRevenue: ECHARTS_DATASOURCE_METRICS_PC_REVENUE,
  pcMAU: ECHARTS_DATASOURCE_METRICS_PC_MAU,
  pcLifeTimePlayers: ECHARTS_DATASOURCE_METRICS_PC_LIFETIMEPLAYERS,
  consoleMetricsTable: ECHARTS_DATASOURCE_METRICS_CONSOLE,
  consoleDigitalRevenue: ECHARTS_DATASOURCE_METRICS_PC_DIGITALREV,
  consolePhysicalRevenue: ECHARTS_DATASOURCE_METRICS_PC_REVENUE,
  consoleMAU: ECHARTS_DATASOURCE_METRICS_PC_MAU,
  consoleLifeTimePlayers: ECHARTS_DATASOURCE_METRICS_PC_LIFETIMEPLAYERS,
} as any;

export const METRICS_MAP: {
  [key: string]: any[];
} = {
  // pc游戏详情页下载 指标配置
  'pc-detail': [
    ...ECHARTS_DATASOURCE_METRICS_PC_DETAIL,
    ...LIVE_STREAMING_METRICS,
    ...STEAMSALES_METRICS_OLD,
  ],
  // console游戏详情页下载 指标配置
  'console-detail': [
    ...ECHARTS_DATASOURCE_METRICS_CONSOLE,
    ...LIVE_STREAMING_METRICS,
    // Famitsu is temporarily unavailable in Intelligence pages.
    // ...JAPAN_SALES_METRICS,
  ],
  'combine-detail': [
    ...ECHARTS_DATASOURCE_METRICS_CONSOLE,
    ...LIVE_STREAMING_METRICS,
    // Famitsu is temporarily unavailable in Intelligence pages.
    // ...JAPAN_SALES_METRICS,
  ],
  // 'console-japansales-detail': [
  //   ...ECHARTS_DATASOURCE_METRICS_CONSOLE,
  //   ...LIVE_STREAMING_METRICS,
  //   ...JAPAN_SALES_METRICS,
  // ],
};

export const GLOBAL_WO_CHINA = 'global_wo_china';
export const GLOBAL = 'global';

// 筛选器配置，通用对象-行
export const INPUTLIST_ROW = {
  key: 'row',
  savePopupVisble: 0,
};

// 筛选器配置，通用inputlist类型-行
export const INPUTLIST_TYPE_ROW = 'row';
// 筛选器配置，通用inputlist类型-左对齐
export const INPUTLIST_TYPE_LEFT = 'left';
// 筛选器配置，通用inputlist类型-右对齐
export const INPUTLIST_TYPE_RIGHT = 'right';

// 融合ID校验规则
// export const COMBINEID_REG = new RegExp(/^[a-zA-Z0-9]+$/);
export const COMBINEID_REG = new RegExp(/^[a-z0-9\-]*$/);

// const COMBINEID_REG = new RegExp(/`^[a-z0-9\-]*$`/);
// const COMBINEID_REG = new RegExp(/^[a-zA-Z0-9\.\-\_\:\/=?]*$/);
